/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var coll = document.querySelectorAll(".collapsible_produktinformationen, .collapsible_garantie");

coll.forEach(function(button) {
  button.addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});


 // Blog Beitrag Buttons
function initPlantingGuideToggle() {
  const buttons = document.querySelectorAll('.PlantingGuide__Button');
  const contents = document.querySelectorAll('.PlantingGuide__Content');

  if (!buttons.length || !contents.length) return; // Falls nichts da ist, abbrechen

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-target');

      contents.forEach(content => {
        content.style.display = 'none';
        content.classList.remove('fade-in');
      });

      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      const targetContent = document.getElementById('PlantingGuide__' + target);
      if (targetContent) {
        targetContent.style.display = 'block';
        setTimeout(() => targetContent.classList.add('fade-in'), 10);
        targetContent.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

// Wiederholt prüfen, ob der HTML-Block aus dem Beitrag geladen ist
function waitForPlantingGuide() {
  if (document.querySelector('.PlantingGuide__Button')) {
    initPlantingGuideToggle(); // Wenn Buttons da sind, init starten
  } else {
    setTimeout(waitForPlantingGuide, 200); // Sonst in 200ms erneut prüfen
  }
}

document.addEventListener('DOMContentLoaded', waitForPlantingGuide);

/* === FGZoom v6 – Carousel + alle Fixes === */
(function () {

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () { try { // ── try-catch schützt nachgelagerten Code (Thumbnails, Filter) vor Runtime-Fehlern

    /* ── Modal DOM erstellen per createElement (robust gegen innerHTML-Sanitizer) ── */
    var existing = document.getElementById('fg-zoom-modal');
    if (existing && existing.parentNode) { existing.parentNode.removeChild(existing); }

    var modal = document.createElement('div');
    modal.id = 'fg-zoom-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.style.display = 'none';

    var closeB = document.createElement('button');
    closeB.className = 'fg-zoom-close';
    closeB.setAttribute('aria-label', 'Schlie\u00dfen');
    modal.appendChild(closeB);

    var stage = document.createElement('div');
    stage.className = 'fg-zoom-stage';
    modal.appendChild(stage);

    var imgEl = document.createElement('img');
    imgEl.className = 'fg-zoom-img';
    imgEl.alt = '';
    stage.appendChild(imgEl);

    var spinner = document.createElement('div');
    spinner.className = 'fg-zoom-spinner';
    stage.appendChild(spinner);

    var prevBtn = document.createElement('button');
    prevBtn.className = 'fg-zoom-nav fg-zoom-prev';
    prevBtn.setAttribute('aria-label', 'Vorheriges Bild');
    prevBtn.textContent = '\u276E';
    modal.appendChild(prevBtn);

    var nextBtn = document.createElement('button');
    nextBtn.className = 'fg-zoom-nav fg-zoom-next';
    nextBtn.setAttribute('aria-label', 'N\u00e4chstes Bild');
    nextBtn.textContent = '\u276F';
    modal.appendChild(nextBtn);

    var counter = document.createElement('div');
    counter.className = 'fg-zoom-counter';
    modal.appendChild(counter);

    document.body.appendChild(modal);

    /* ── Konstanten ──────────────────────────────────────────────── */
    var SCALE_MIN    = 1.0;
    var SCALE_CLICK  = 2.5;
    var SCALE_MAX    = 8.0;
    var WHEEL_STEP   = 0.08;   // proportional: scale * (1 ± WHEEL_STEP)
    var PINCH_GAIN   = 0.65;
    var PINCH_DEAD   = 2.0;    // px Mindest-Distanzänderung
    var SWIPE_THRESH = 55;     // px horizontal für Carousel-Wechsel

    /* ── Zoom-State ──────────────────────────────────────────────── */
    var scale = SCALE_MIN, tx = 0, ty = 0;
    var pts = new Map();
    var lastDist = null, pinchPivot = null;
    var isPointerTouch = false;
    var lastTapTime = 0;

    /* ── Carousel-State ──────────────────────────────────────────── */
    var images = [];       // [{src, alt}, ...]
    var currentIdx = 0;
    var swipeStartX = 0, swipeStartY = 0;

    /* ── Transform ───────────────────────────────────────────────── */
    /* KORREKTUR: translate() DANN scale() – tx/ty sind Screen-Pixel,
       kein Koordinatensystem-Mismatch beim Clamping mehr.             */
    function apply() {
      imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      imgEl.classList.toggle('fg-zoom-zoomed', scale > SCALE_MIN + 0.05);
    }

    /* KORREKTUR: getBoundingClientRect() liefert gerenderte Pixel,
       tx/ty sind jetzt ebenfalls in Screen-Pixeln → direktes Clampen. */
    function clampPan() {
      var r = imgEl.getBoundingClientRect();
      var s = stage.getBoundingClientRect();
      var overX = Math.max(0, (r.width  - s.width)  / 2);
      var overY = Math.max(0, (r.height - s.height) / 2);
      tx = Math.max(-overX, Math.min(overX, tx));
      ty = Math.max(-overY, Math.min(overY, ty));
    }

    function resetZoom() { scale = SCALE_MIN; tx = 0; ty = 0; apply(); }

    /* ── Carousel: alle sichtbaren Bildslides sammeln ───────────── */
    function collectImages() {
      function buildList(selector) {
        var result = [];
        document.querySelectorAll(selector).forEach(function (cell) {
          if (cell.closest('.Carousel__Cell--konfigurator')) return;
          if (cell.getAttribute('data-media-type') === 'konfigurator') return;
          /* data-media-position="duplicate" NICHT filtern: Bei Konfigurator-Produkten
             erscheint das erste Bild ausschließlich als Duplikat-Slide (das Original
             wird im Liquid-Loop per continue übersprungen). Den Duplikat-Check
             würde das erste Bild komplett aus dem Zoom ausschließen. */
          var img = cell.querySelector('img');
          if (!img) return;
          var src = img.getAttribute('data-zoom-src')
                 || img.getAttribute('data-original-src')
                 || img.getAttribute('data-src')   /* Lazysizes-Fallback */
                 || img.currentSrc
                 || img.src;
          /* Lazysizes-Platzhalter (1×1 GIF / about:blank) überspringen */
          if (!src || src === 'about:blank' || src.indexOf('_1x1.') !== -1) return;
          result.push({ src: src, alt: img.alt || '' });
        });
        return result;
      }
      /* 1. Versuch: nur sichtbare Slides */
      var result = buildList('.Product__Slideshow .Product__SlideItem--image:not(.VariantFilter--hidden)');
      /* 2. Fallback: alle Slides – falls Variant-Filter fälschlich alles versteckt hat */
      if (!result.length) {
        result = buildList('.Product__Slideshow .Product__SlideItem--image');
      }
      return result;
    }

    function updateNav() {
      var show = images.length > 1;
      prevBtn.style.display = show ? '' : 'none';
      nextBtn.style.display = show ? '' : 'none';
      if (show) {
        counter.textContent = (currentIdx + 1) + ' / ' + images.length;
        counter.style.display = '';
      } else {
        counter.style.display = 'none';
      }
    }

    /* ── Bild laden (Fade-Übergang + Ladeindikator) ──────────────── */
    function loadSlide(idx, dir) {
      if (!images[idx]) return;
      var entry = images[idx];

      stage.classList.add('is-loading');
      imgEl.classList.add('is-fading');

      var delay = (dir !== 0 && imgEl.getAttribute('src')) ? 130 : 0;

      setTimeout(function () {
        /* Zoom sofort zurücksetzen, bevor das neue Bild erscheint */
        scale = SCALE_MIN; tx = 0; ty = 0;
        imgEl.style.transform = 'translate(0px,0px) scale(1)';
        imgEl.classList.remove('fg-zoom-zoomed');

        imgEl.src = entry.src;
        imgEl.alt = entry.alt;

        function onDone() {
          stage.classList.remove('is-loading');
          imgEl.classList.remove('is-fading');
        }
        if (imgEl.complete && imgEl.naturalWidth) {
          onDone();
        } else {
          imgEl.onload  = onDone;
          imgEl.onerror = onDone;
        }
      }, delay);
    }

    function navigate(dir) {
      currentIdx = (currentIdx + dir + images.length) % images.length;
      loadSlide(currentIdx, dir);
      updateNav();
    }

    /* ── Öffnen / Schließen ──────────────────────────────────────── */
    function isOpen() { return modal.getAttribute('aria-hidden') === 'false'; }

    function open(imgElement) {
      images = collectImages();
      if (!images.length) { return; }

      /* Geklicktes Bild im Array finden */
      var clickedSrc = imgElement
        ? (imgElement.getAttribute('data-zoom-src') || imgElement.getAttribute('data-original-src') || imgElement.currentSrc || imgElement.src)
        : null;
      currentIdx = 0;
      if (clickedSrc) {
        var found = images.findIndex(function (i) { return i.src === clickedSrc; });
        if (found >= 0) currentIdx = found;
      }

      /* State zurücksetzen */
      scale = SCALE_MIN; tx = 0; ty = 0;
      isPointerTouch = false;
      pts.clear(); lastDist = null; pinchPivot = null;

      /* Modal einblenden – void offsetHeight erzwingt Reflow,
         damit die CSS-opacity-Transition sicher anspringt         */
      modal.style.display = 'flex';
      void modal.offsetHeight;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fg-zoom-lock');

      loadSlide(currentIdx, 0);
      updateNav();
    }

    function close() {
      modal.setAttribute('aria-hidden', 'true'); /* CSS fade-out startet */
      setTimeout(function () {
        modal.style.display = 'none';
        document.body.classList.remove('fg-zoom-lock');
        pts.clear(); lastDist = null; pinchPivot = null;
        isPointerTouch = false;
        imgEl.src = '';
        imgEl.onload = null;
        imgEl.onerror = null;
        scale = SCALE_MIN; tx = 0; ty = 0;
        stage.classList.remove('is-loading');
        imgEl.classList.remove('is-fading', 'fg-zoom-zoomed');
        images = [];
      }, 220);
    }

    /* ── Desktop Maus-Panning & Klick-Zoom ──────────────────────── */
    /* Merkt ob die Maus zwischen down und up bewegt wurde (→ Drag, nicht Click) */
    var mouseDragMoved = false;

    stage.addEventListener('mousedown', function (e) {
      if (isPointerTouch) return;
      if (e.button !== 0) return;
      mouseDragMoved = false;
    });

    stage.addEventListener('mousemove', function (e) {
      if (isPointerTouch) return;
      if (!(e.buttons & 1)) return;               /* linke Maustaste gehalten */
      if (scale <= SCALE_MIN + 0.05) return;       /* nur wenn gezoomt */
      if (Math.abs(e.movementX) > 1 || Math.abs(e.movementY) > 1) {
        mouseDragMoved = true;
      }
      tx += e.movementX;
      ty += e.movementY;
      clampPan(); apply();
    });

    stage.addEventListener('click', function (e) {
      if (isPointerTouch) return;
      if (mouseDragMoved) { mouseDragMoved = false; return; }   /* war Drag → kein Zoom */

      /* Koordinatenbasiert prüfen ob auf dem Bild geklickt wurde.
         e.target ist durch setPointerCapture unzuverlässig (zeigt auf stage statt img),
         daher prüfen wir die tatsächliche Mausposition gegen das Bild-Rechteck. */
      var imgRect = imgEl.getBoundingClientRect();
      var onImage = imgRect.width > 0 &&
                    e.clientX >= imgRect.left && e.clientX <= imgRect.right &&
                    e.clientY >= imgRect.top  && e.clientY <= imgRect.bottom;

      if (!onImage) { close(); return; }

      e.preventDefault();
      e.stopPropagation();

      var s  = stage.getBoundingClientRect();
      var px = e.clientX - s.left - s.width  / 2;
      var py = e.clientY - s.top  - s.height / 2;

      if (scale <= SCALE_MIN + 0.05) {
        var newScale = SCALE_CLICK;
        var factor   = newScale / scale;
        tx = tx * factor + px * (1 - factor);
        ty = ty * factor + py * (1 - factor);
        scale = newScale;
      } else {
        scale = SCALE_MIN; tx = 0; ty = 0;
      }
      clampPan(); apply();
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    /* ── Mausrad-Zoom – exponentiell, sanft für Trackpad & Mausrad ── */
    stage.addEventListener('wheel', function (e) {
      if (isPointerTouch) return;
      e.preventDefault();
      var delta = e.deltaY;
      if (e.deltaMode === 1) delta *= 15;   /* Zeilen-Modus → Pixel */
      if (e.deltaMode === 2) delta *= 300;  /* Seiten-Modus → Pixel */
      /* Math.pow(0.998, delta): kleines delta (Trackpad) → sanfter Zoom,
         großes delta (Mausrad ~100px) → spürbarer Zoom */
      var factor   = Math.pow(0.998, delta);
      var newScale = Math.max(SCALE_MIN, Math.min(SCALE_MAX, scale * factor));
      var r        = stage.getBoundingClientRect();
      var px       = e.clientX - r.left - r.width  / 2;
      var py       = e.clientY - r.top  - r.height / 2;
      var f        = newScale / scale;
      tx = tx * f + px * (1 - f);
      ty = ty * f + py * (1 - f);
      scale = newScale;
      clampPan(); apply();
    }, { passive: false });

    /* ── Navigationsbuttons ───────────────────────────────────────── */
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); navigate(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); navigate(1); });

    /* ── Keyboard ─────────────────────────────────────────────────── */
    window.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowLeft')  navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    closeB.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });

    /* ── Touch / Pointer Events ───────────────────────────────────── */
    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      isPointerTouch = (e.pointerType === 'touch');

      if (isPointerTouch && pts.size === 1) {
        swipeStartX = e.clientX;
        swipeStartY = e.clientY;

        /* Doppeltipp → Zoom zurücksetzen */
        var now = Date.now();
        if (now - lastTapTime < 300) { resetZoom(); lastTapTime = 0; return; }
        lastTapTime = now;
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      var prev = pts.get(e.pointerId);
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pts.size === 1 && isPointerTouch && scale > SCALE_MIN + 0.05) {
        /* Pan (nur wenn gezoomt) – tx/ty in Screen-Pixeln, kein Dämpfungshack nötig */
        tx += e.clientX - prev.x;
        ty += e.clientY - prev.y;
        clampPan(); apply();
      } else if (pts.size >= 2) {
        /* Pinch-Zoom */
        var arr    = Array.from(pts.values());
        var p1 = arr[0], p2 = arr[1];
        var dist   = Math.hypot(p2.x - p1.x, p2.y - p1.y);
        var center = { x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2 };

        if (lastDist === null) { lastDist = dist; pinchPivot = center; return; }
        if (Math.abs(dist - lastDist) < PINCH_DEAD) { lastDist = dist; return; }

        var rawRatio = dist / lastDist;
        var ratio    = Math.exp(Math.log(rawRatio) * PINCH_GAIN);
        var newScale = Math.max(SCALE_MIN, Math.min(SCALE_MAX, scale * ratio));

        var sRect  = stage.getBoundingClientRect();
        var px     = pinchPivot.x - sRect.left - sRect.width  / 2;
        var py     = pinchPivot.y - sRect.top  - sRect.height / 2;
        var factor = newScale / scale;
        tx = tx * factor + px * (1 - factor);
        ty = ty * factor + py * (1 - factor);
        scale = newScale;
        clampPan(); apply();
        lastDist = dist;
      }
    }, { passive: false });

    stage.addEventListener('pointerup', function (e) {
      var endX = e.clientX, endY = e.clientY;

      /* Carousel-Swipe: nur wenn nicht gezoomt und klar horizontal */
      if (isPointerTouch && pts.size === 1 && scale <= SCALE_MIN + 0.05 && images.length > 1) {
        var dx = endX - swipeStartX;
        var dy = endY - swipeStartY;
        if (Math.abs(dx) > SWIPE_THRESH && Math.abs(dx) > Math.abs(dy) * 1.5) {
          navigate(dx < 0 ? 1 : -1);
        }
      }
      pts.delete(e.pointerId);
      if (pts.size < 2) { lastDist = null; pinchPivot = null; }
    });

    stage.addEventListener('pointercancel', function (e) {
      pts.delete(e.pointerId);
      if (pts.size < 2) { lastDist = null; pinchPivot = null; }
    });

    /* ── Galerie-Integration ──────────────────────────────────────── */
    function isKonfigurator(el) {
      return !!(el.closest('[data-media-type=”konfigurator”]') || el.closest('.Carousel__Cell--konfigurator'));
    }

    /* ── Galerie-Click- und Touch-Handler ───────────────────────── */

    /* Klick auf Galeriebild → Zoom öffnen.
       Capture-Phase (letztes Argument = true): Handler läuft VOR Flickity,
       Prestige-Delegates und allen anderen Bubble-Phase-Handlern.
       Dadurch kann kein inneres Element den Klick mehr "schlucken".
       ev.target kann AspectRatio-div, Image__Loader-span oder img sein →
       daher Cell ermitteln, dann img darin suchen. */
    document.addEventListener('click', function (ev) {
      if (isOpen()) return;
      if (!ev.target.closest('.Product__Slideshow')) return;
      var cell = ev.target.closest('.Product__SlideItem--image');
      if (!cell || isKonfigurator(cell)) return;
      var img = cell.querySelector('img');
      if (!img) return;
      ev.preventDefault();
      ev.stopPropagation();
      open(img);
    }, true /* capture */);

    /* Pinch-to-open (Touch) – gDidOpen verhindert sofortiges Zoom im Modal */
    var gallery = document.querySelector('.Product__Slideshow');
    if (gallery) {
      var gpts = new Map(), gLastDist = null, gActiveImg = null, gDidOpen = false;

      gallery.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch') return;
        var cell = e.target.closest('.Product__SlideItem--image');
        if (!cell || isKonfigurator(cell)) return;
        gActiveImg = cell.querySelector('img');
        if (gActiveImg) gpts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        gDidOpen = false;
      }, { passive: true });

      gallery.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'touch' || !gpts.has(e.pointerId)) return;
        gpts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (isOpen() || gDidOpen) return;
        if (gpts.size >= 2 && gActiveImg) {
          var arr  = Array.from(gpts.values());
          var dist = Math.hypot(arr[1].x - arr[0].x, arr[1].y - arr[0].y);
          if (gLastDist === null) { gLastDist = dist; return; }
          if (Math.abs(dist - gLastDist) > 8) {
            gDidOpen = true;
            e.preventDefault(); e.stopPropagation();
            open(gActiveImg);
          }
        }
      }, { passive: false });

      function gEnd(e) {
        gpts.delete(e.pointerId);
        if (gpts.size < 2) gLastDist = null;
        if (gpts.size === 0) { gActiveImg = null; gDidOpen = false; }
      }
      gallery.addEventListener('pointerup',     gEnd, { passive: true });
      gallery.addEventListener('pointercancel', gEnd, { passive: true });
    }

    /* ── Zoom-Button → selbes Verhalten wie Bild-Klick ─────────────
       Strategie: Button-Klick löst einen echten MouseEvent auf dem
       aktuell sichtbaren Bild aus. Unser bestehender Image-Capture-
       Handler (der bereits funktioniert) öffnet dann fg-zoom.
       So brauchen wir keine doppelte Logik und kein PhotoSwipe-Override.
    ── */
    var zoomBtn = document.querySelector('[data-action="open-product-zoom"]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var selectedCell = document.querySelector('.Product__Slideshow .is-selected.Product__SlideItem--image')
                        || document.querySelector('.Product__Slideshow .Product__SlideItem--image');
        var img = selectedCell ? selectedCell.querySelector('img') : null;
        if (img) {
          /* Klick auf das Bild auslösen – unser Capture-Handler öffnet fg-zoom */
          img.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }
      }, true /* capture: vor Prestiges PhotoSwipe-Handler */);
    }

    window.FGZoom = { open: open, close: close };

  } catch (err) {
    /* Fehler im Zoom-Setup niemals still schlucken, aber auch nicht den Rest von
       custom.js (Thumbnails, Variant-Filter) zum Absturz bringen */
    console.error('[FGZoom] Setup-Fehler:', err);
  }
  });

})();


/* =========================
   Mobile Thumbnails (per media-id) + Active-Markierung
   ========================= */
document.addEventListener("DOMContentLoaded", function () {
  var sliderEl = document.querySelector(".Product__Slideshow.Carousel");
  if (!sliderEl) return;

  function getFlkty() {
    return window.Flickity && window.Flickity.data ? window.Flickity.data(sliderEl) : null;
  }

  function markActiveThumbByMediaId(mediaId) {
    var thumbs = document.querySelectorAll(".Product__MobileThumbnail");
    thumbs.forEach(function (t) {
      var isMatch = t.getAttribute("data-media-id") === mediaId && !t.classList.contains("VariantFilter--hidden");
      t.classList.toggle("active", !!isMatch);
    });
    var active = document.querySelector(".Product__MobileThumbnail.active");
    if (active) {
      // scrollIntoView mit block:"nearest" scrollt auf iOS die gesamte Seite (horizontal + vertikal).
      // Stattdessen: nur den Thumbnail-Wrapper direkt scrollt – Seite bleibt stabil.
      var wrapper = active.closest('.Product__MobileThumbnailsWrapper');
      if (wrapper) {
        var scrollTarget = active.offsetLeft - (wrapper.offsetWidth / 2) + (active.offsetWidth / 2);
        wrapper.scrollTo({ left: scrollTarget, behavior: 'smooth' });
      }
    }
  }

  function getSelectedCellEl() {
    var flkty = getFlkty();
    if (!flkty) return null;
    if (flkty.selectedElement) return flkty.selectedElement;
    var cells = sliderEl.querySelectorAll(".flickity-slider > *");
    return cells[flkty.selectedIndex] || null;
  }

  function getCellMediaId(cellEl) {
    if (!cellEl) return null;
    var id = cellEl.getAttribute("data-media-id");
    if (id) return id;
    // Fallback: wenn z. B. der Konfigurator-Slide keine media-id hat, suche erste sichtbare Bildzelle
    var vis = sliderEl.querySelector('.flickity-slider > *:not(.VariantFilter--hidden)[data-media-id]');
    return vis ? vis.getAttribute("data-media-id") : null;
  }

  // --- [ADD] Active-Sync-Helper: leitet Active-Thumb aus Flickity ab ---
function updateActiveThumbFromFlickity() {
  var flkty = getFlkty();
  if (!flkty) return;

  var cell = getSelectedCellEl();
  // wenn selektierte Zelle (noch) versteckt ist, hier nichts tun – der Filter repariert das
  if (cell && cell.classList.contains("VariantFilter--hidden")) return;

  var mediaId = getCellMediaId(cell);
  if (mediaId) markActiveThumbByMediaId(mediaId);
}


  // Thumbs klicken → per media-id selektieren (nicht per Index)
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest('.Product__MobileThumbnail[data-media-id]');
    if (!thumb) return;
    var mediaId = thumb.getAttribute("data-media-id");
    var flkty = getFlkty();
    if (!flkty) return;

    var cells = sliderEl.querySelectorAll(".flickity-slider > *");
    for (var i = 0; i < cells.length; i++) {
      var c = cells[i];
      if (!c.classList.contains("VariantFilter--hidden") && c.getAttribute("data-media-id") === mediaId) {
        try { flkty.selectCell(c, false, true); } catch (e2) { flkty.select(i, false, true); }
        markActiveThumbByMediaId(mediaId);
        break;
      }
    }
  }, { passive: true });

  // Wenn Flickity selektiert, aktiv-Thumb updaten
  (function waitForFlickity(attempts) {
    attempts = attempts || 20;
    var flkty = getFlkty();
    if (flkty) {
      try {
        flkty.options.cellSelector = '.Carousel__Cell:not(.VariantFilter--hidden), .Product__SlideItem:not(.VariantFilter--hidden)';
        flkty.reloadCells();
        flkty.resize();
        flkty.updateDraggable && flkty.updateDraggable();
      } catch(e){}

      flkty.on("select", function () {
        updateActiveThumbFromFlickity();
      });

      return;
    }
    if (attempts <= 0) return;
    setTimeout(function () { waitForFlickity(attempts - 1); }, 150);
  })();

  // Nach jedem Filterdurchlauf (siehe unten) – Layout & Active reparieren
  document.addEventListener("fg:variantFilter:after", function () {
    var flkty = getFlkty();
    if (flkty) { try { flkty.reloadCells(); flkty.resize(); } catch(e){} }
    var cell = getSelectedCellEl();
    var mediaId = getCellMediaId(cell);
    if (mediaId) markActiveThumbByMediaId(mediaId);
  });
  updateActiveThumbFromFlickity();
  requestAnimationFrame(updateActiveThumbFromFlickity);
});


/* =========================
   Varianten-Bildfilter (per Alt-Tag [v=...])
   - Keine Auto-Selektion mehr (außer aktuelle Auswahl wäre versteckt)
   - Keine Platzhalter: display:none + reloadCells()
   ========================= */
(function () {
  function norm(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .replace(/[\u00d8]/g, "ø")
      .replace(/\s+/g, "")
      .replace(/cm/g, "")
      .replace(/[.,]/g, "");
  }
  function canonNum(str) {
    let n = (str || "").replace(/^0+/, "");
    n = n.replace(/0+$/, "");
    return n === "" ? "0" : n;
  }
function extractTokensFromString(val) {
  const tokens = new Set();

  // 1) Größe IM ORIGINALSTRING (mit Leerzeichen) auslesen
  const raw = (val || "").toString().trim().toLowerCase();
  const firstToken = raw.split(/\s+/)[0]; // erstes "Wort"

  if (/^(xxxl|xxl|xl|xxs|xs|s|m|l)$/.test(firstToken)) {
    tokens.add(firstToken);
  }

  // 2) Danach normalisieren für Maß-Tokens
  const normalized = norm(raw);

  const rx = /(ø|ö|o|d|h|b|t)\s*:?(\d{1,6})/g;
  let m;
  while ((m = rx.exec(normalized)) !== null) {
    let key = m[1];
    if (key === "o" || key === "d") key = "ø";
    const num = canonNum(m[2]);
    tokens.add(key + num);
  }

  return tokens;
}
  function readVariantsJSON() {
    try {
      const el = document.getElementById("fg-variants");
      if (!el) return null;
      return JSON.parse(el.textContent || "[]");
    } catch (e) { return null; }
  }
  function getCurrentVariant(variants) {
    if (!variants || !variants.length) return null;
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) {
      const vid = parseInt(idInput.value, 10);
      const byId = variants.find(v => v && v.id === vid);
      if (byId) return byId;
    }
    return variants.find(v => v && v.available) || variants[0] || null;
  }
  function getSelectedVariantTokens(overrideVariant) {
    const tokens = new Set();
    const variants = readVariantsJSON();
    const variant = overrideVariant || getCurrentVariant(variants);
    if (variant) {
      ["option1", "option2", "option3"].forEach(k => {
        if (variant[k]) extractTokensFromString(variant[k]).forEach(t => tokens.add(t));
      });
      if (variant.title) extractTokensFromString(variant.title).forEach(t => tokens.add(t));
    }
    return tokens;
  }
  function parseAltToGroups(altRaw) {
    const groups = [];
    if (!altRaw) return groups;
    const matches = altRaw.toString().match(/\[v\s*=\s*([^\]]+)\]/gi);
    if (!matches) return groups;
    matches.forEach((m) => {
      const inside = m.replace(/\[v\s*=\s*/i, "").replace(/\]$/, "");
      const raw = norm(inside).split("|").filter(Boolean);
      const canon = raw.map(tok => {
        const mm =
          tok.match(/^(xxxl|xxl|xl|xxs|xs|s|m|l)$/) ||
          tok.match(/^(ø|ö|o|d|h|b|t)(\d+)$/);
        if (!mm) return tok;
        if (mm.length === 2) return mm[1];
        let key = mm[1];
        if (key === "o" || key === "d") key = "ø";
        return key + canonNum(mm[2]);
      });
      if (canon.length) groups.push(canon);
    });
    return groups;
  }
  function shouldShow(groups, selectedSet) {
    if (!groups || groups.length === 0) return true; // ungetaggt => immer
    return groups.some(group =>
      group.every(tok => {
        if (/^(xxxl|xxl|xl|xxs|xs|s|m|l)$/.test(tok)) return selectedSet.has(tok);
        const m = tok.match(/^(ø|ö|h|b|t)(\d+)$/);
        if (!m) return selectedSet.has(tok);
        const key = m[1], num = m[2];
        for (const s of selectedSet) {
          const ms = s.match(/^(ø|ö|h|b|t)(\d+)$/);
          if (!ms) continue;
          if (ms[1] === key && ms[2] === num) return true;
        }
        return false;
      })
    );
  }

  function getFlkty() {
    var slider = document.querySelector(".Product__Slideshow");
    return (slider && window.jQuery) ? jQuery(slider).data("flickity") : null;
  }

  function selectNearestVisibleIfHidden() {
    var slider = document.querySelector(".Product__Slideshow");
    var flkty = getFlkty();
    if (!slider || !flkty) return;

    var cells = slider.querySelectorAll(".flickity-slider > *");
    var curr = cells[flkty.selectedIndex];

    // Wenn aktuelle Zelle sichtbar, NICHT springen (dein Wunsch)
    if (curr && !curr.classList.contains("VariantFilter--hidden")) return;

    // Sonst: nächste sichtbare rechts, sonst links
    var targetIndex = -1;
    for (var i = flkty.selectedIndex; i < cells.length; i++) {
      if (!cells[i].classList.contains("VariantFilter--hidden")) { targetIndex = i; break; }
    }
    if (targetIndex === -1) {
      for (var j = flkty.selectedIndex; j >= 0; j--) {
        if (!cells[j].classList.contains("VariantFilter--hidden")) { targetIndex = j; break; }
      }
    }
    if (targetIndex > -1) {
      try { flkty.selectCell(cells[targetIndex], false, true); } catch (e) { flkty.select(targetIndex, false, true); }
    }
  }

  function applyVariantImageFilter(overrideVariant) {
    const selected = getSelectedVariantTokens(overrideVariant);

    // Slides
    var slideSel = ".Product__Slideshow .Product__SlideItem, .Product__Slideshow .Carousel__Cell";
    var slides = document.querySelectorAll(slideSel);
    slides.forEach(function (slide) {
      var groups = parseAltToGroups(slide.getAttribute("data-alt"));
      if (shouldShow(groups, selected)) {
        slide.classList.remove("VariantFilter--hidden");
        slide.setAttribute("aria-hidden", "false");
      } else {
        slide.classList.add("VariantFilter--hidden");
        slide.setAttribute("aria-hidden", "true");
      }
    });

    // Thumbs & Dots (ALLE, die kein Slide sind)
    var navItems = document.querySelectorAll('[data-media-id]:not(.Carousel__Cell):not(.Product__SlideItem)');
    navItems.forEach(function (item) {
      var groups = parseAltToGroups(item.getAttribute("data-alt"));
      if (shouldShow(groups, selected)) item.classList.remove("VariantFilter--hidden");
      else item.classList.add("VariantFilter--hidden");
    });

  // --- SICHERUNG: falls wirklich 0 sichtbare Slides übrig sind ---
var slider = document.querySelector('.Product__Slideshow');
var anyVisible = slider && slider.querySelector('.Carousel__Cell:not(.VariantFilter--hidden), .Product__SlideItem:not(.VariantFilter--hidden)');
if (!anyVisible) {
  // Fallback: erstes echtes Slide wieder sichtbar machen (meist erstes Bild)
  var firstCell = slider && slider.querySelector('.Carousel__Cell, .Product__SlideItem');
  if (firstCell) {
    firstCell.classList.remove('VariantFilter--hidden');
    firstCell.setAttribute('aria-hidden', 'false');
  }
}
// ---------------------------------------------------------------

// Flickity: versteckte Slides komplett aus dem Carousel entfernen (ohne DOM zu löschen)
var flkty = getFlkty();
if (flkty) {
  // Nur echte sichtbare Slides als Cells
  flkty.options.cellSelector = '.Carousel__Cell:not(.VariantFilter--hidden), .Product__SlideItem:not(.VariantFilter--hidden)';

  try {
    flkty.reloadCells();
    flkty.resize();
    flkty.updateDraggable && flkty.updateDraggable();
  } catch(e){}

  // Falls aktuell selektierte Zelle nun unsichtbar ist → zur nächsten sichtbaren springen
  selectNearestVisibleIfHidden();

  // Sicherheit im nächsten Frame (nach Lazyload/Reflow)
  requestAnimationFrame(function(){
    try {
      flkty.reloadCells();
      flkty.resize();
      flkty.updateDraggable && flkty.updateDraggable();
      selectNearestVisibleIfHidden();
      flkty.select(flkty.selectedIndex, false, true);
    } catch(e){}
  });
}


    // Event für nachgelagerte UI (Active-Thumb etc.)
    document.dispatchEvent(new CustomEvent("fg:variantFilter:after"));
  }

  // Events
  document.addEventListener("variant:change", function (e) {
    applyVariantImageFilter(e && e.detail && e.detail.variant);
  });
  document.addEventListener("shopify:variant:change", function (e) {
    applyVariantImageFilter(e && e.detail && e.detail.variant);
  });
  document.addEventListener("variant:changed", function (e) {
    applyVariantImageFilter(e && e.detail && e.detail.variant);
  });
  document.addEventListener("product:variant:changed", function (e) {
    applyVariantImageFilter(e && e.detail && e.detail.variant);
  });

  // Fallback: beobachte Variant-ID (falls das Theme keine Events feuert)
  (function observeVariantId() {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!idInput) return;
    let lastVal = idInput.value;
    const obs = new MutationObserver(() => {
      if (idInput.value !== lastVal) {
        lastVal = idInput.value;
        applyVariantImageFilter();
      }
    });
    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
  })();

  // Initial: nur filtern (kein Auto-Jump)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function(){ applyVariantImageFilter(); });
  } else {
    applyVariantImageFilter();
  }

  // Debug-Helfer
  window.__fg_dbg = {
    getSelectedVariantTokens: () => getSelectedVariantTokens(),
    parseAltToGroups,
    norm
  };
})();

/* =========================
   Cart / Cart Drawer: vor Checkout für alle Cart-Lines _Zustellfenster anhand heute berechnen.
   ========================= */
   // === Checkout Guard: Zustellfenster kurz vor Checkout setzen ===

(function(){
  if (window.FGCheckoutGuardInitialized) return;
  window.FGCheckoutGuardInitialized = true;

  /* Die Datumsrechnung (Cutoff, Feiertage, Werktage, Format) steht seit
     genau einmal im Theme: snippets/fg-zustellfenster.liquid, inline
     im head. Hier lag bis dahin eine zweite Kopie, die mit der in
     shipping-profile.liquid leicht auseinandergelaufen war - und weil das
     Zustellfenster eine Line-Item-Property ist, hat jede Abweichung im
     Warenkorb eine zweite Position erzeugt statt die Menge zu erhoehen.
     Siehe README 34bb. */
  // Wie lange darf auf das Schreiben der Properties gewartet werden,
  // bevor der Kunde in jedem Fall zum Checkout geschickt wird.
  var FG_SYNC_TIMEOUT_MS = 1200;
  // Maximale Wartezeit nach Klick auf "Zur Kasse", falls der Sync noch laeuft
  // (mehrere Positionen werden nacheinander geschrieben, 1,2 s reichen dafuer nicht).
  var FG_CLICK_MAX_WAIT_MS = 3000;
  // Pruefung "Warenkorb noch gleich?" beim Klick auf Zur Kasse (nur Lesen)
  var FG_SIG_TIMEOUT_MS = 800;
  var FG_DEBUG = false;
  function log(){ if (FG_DEBUG && window.console) console.log.apply(console, arguments); }

  function fgCutoffHour(){
    var cfg = window.FGZustellfensterConfig;
    return (cfg && cfg.cutoffHour != null) ? cfg.cutoffHour : 12;
  }

  /* ---------------------------------------------------------------
     Gültigkeitsstempel
     Das berechnete Zustellfenster hängt NUR vom Kalendertag und davon
     ab, ob die Cutoff-Zeit überschritten ist. Solange sich der Stempel
     nicht ändert, sind bereits geschriebene Werte noch korrekt.
  --------------------------------------------------------------- */
  function currentStamp(){
    var now = new Date();
    var half = (now.getHours() >= fgCutoffHour()) ? 'PM' : 'AM';
    return now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()+'-'+half;
  }

  var state = {
    syncedStamp: null,   // Stempel des letzten erfolgreichen Syncs
    dirty: true,         // Warenkorb geändert -> Sync nötig
    running: null,       // laufendes Sync-Promise
    navigating: false,   // Weiterleitung eingeleitet -> weitere Klicks ignorieren
    syncedSig: null      // Inhalt des Warenkorbs beim letzten Sync (Variante:Menge)
  };

  /* FG 27.10.2026: Fingerabdruck des Warenkorbs. Bestellung 38918 hatte im
     Attribut _Lieferzeiten noch einen Artikel, den der Kunde nach dem letzten
     Sync entfernt hatte - das Gesamtfenster war dadurch zu lang. Beim Klick
     auf "Zur Kasse" wird deshalb verglichen, ob der Warenkorb noch derselbe
     ist wie beim letzten Sync. */
  function cartSig(cart){
    var m = {};
    ((cart && cart.items) || []).forEach(function(it){
      if (!it || it.requires_shipping === false) return;
      var k = String(it.variant_id);
      m[k] = (m[k] || 0) + (it.quantity || 0);
    });
    return Object.keys(m).sort().map(function(k){ return k + ':' + m[k]; }).join(',');
  }

  function markDirty(){ state.dirty = true; state.gen = (state.gen || 0) + 1; }

  /* ---------------------------------------------------------------
     fetch mit Timeout (AbortController), damit ein hängender Request
     den Kunden nicht dauerhaft blockiert.
  --------------------------------------------------------------- */
  function fetchWithTimeout(url, options, ms){
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var opts = Object.assign({}, options || {});
    if (ctrl) opts.signal = ctrl.signal;
    var timer = setTimeout(function(){ if (ctrl) ctrl.abort(); }, ms || FG_SYNC_TIMEOUT_MS);
    return fetch(url, opts).then(function(r){
      clearTimeout(timer);
      return r;
    }).catch(function(err){
      clearTimeout(timer);
      throw err;
    });
  }

  /* ===============================================================
     FG 26.10.2026: Lieferzeiten NUR NOCH als Warenkorb-Attribute.

     Bis hier standen _Lieferzeit und _Zustellfenster als Properties in
     jeder Warenkorbzeile, und der Guard schrieb sie per /cart/change.js
     nach. Properties sind Teil der Identitaet einer Zeile - daraus kamen
     die wiederkehrenden Fehler:
       - derselbe Artikel an zwei Tagen hinzugefuegt -> anderes Fenster ->
         zwei Zeilen statt Menge 2
       - change.js schreibt die Menge mit, die der Guard gerade kennt;
         aendert der Kunde parallel die Menge, kann sie zurueckspringen
       - der pageshow-Aufraeumer (Zurueck vom Checkout) schrieb ebenfalls
         in die Zeilen
       - Zubehoer/Cross-Sell/Sticky schickten bei fehlendem Bestand gar
         keine _Lieferzeit -> Zeile fehlte im Gesamtfenster (Bestellung
         38898: Charlie XL bei Bestand -2, Mail zeigte 28.-30. Oktober)

     Jetzt fasst der Guard keine Zeile mehr an. Er bestimmt fuer jede
     Variante im Warenkorb die Lieferzeit selbst - nach Bestand und
     GESAMTmenge im Warenkorb, mit derselben Regel wie die Produktseite
     (window.FGWirksameLieferzeit, snippets/fg-zustellfenster.liquid) -
     und schreibt per /cart/update.js nur Warenkorb-Attribute:
       _GesamtZustellfenster  spaetestes Fenster aller Zeilen
       _Lieferzeiten          je Variante "id~Lieferzeit~Fenster", mit " | "
                              getrennt (Bestellbestaetigung, Packstation)
     Die Attribute landen an der Bestellung (customAttributes).

     Lieferzeit-Daten je Produkt: /products/<handle>?view=fg-lieferzeit
     (templates/product.fg-lieferzeit.liquid). Fehlen sie fuer eine Zeile
     (Abruf fehlgeschlagen) oder ergibt sich kein Fenster, bleibt
     _GesamtZustellfenster LEER - lieber keine Angabe als eine zu kurze.
  =============================================================== */
  var FG_LZ_TIMEOUT_MS = 1500;
  // Im Hintergrund wartet niemand -> grosszuegige Zeit, auch bei langsamem Mobilnetz (27.10.2026)
  var FG_BG_TIMEOUT_MS = 8000;
  function ladeLieferzeitDaten(cart, ms){
    var handles = {};
    (cart.items || []).forEach(function(it){
      if (it && it.handle && it.requires_shipping !== false) handles[it.handle] = true;
    });
    var liste = Object.keys(handles);
    if (!liste.length || !window.FGWirksameLieferzeit) return Promise.resolve({});
    var daten = {};
    return Promise.all(liste.map(function(h){
      return fetchWithTimeout('/products/' + encodeURIComponent(h) + '?view=fg-lieferzeit', {}, ms || FG_LZ_TIMEOUT_MS)
        .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function(t){ daten[h] = JSON.parse(t); })
        .catch(function(err){ log('[FG Checkout Guard] Lieferzeit-Daten fehlen fuer', h, err); });
    })).then(function(){ return daten; });
  }

  /* Reine Rechnung, kein Netzwerk: { attribute, eintraege } */
  function lieferzeitenBerechnen(cart, lz){
    var mengeJe = {}, reihenfolge = [], idHandle = {};
    (cart.items || []).forEach(function(item){
      if (!item || item.requires_shipping === false) return;
      var k = String(item.variant_id);
      if (!(k in mengeJe)) { mengeJe[k] = 0; reihenfolge.push(k); idHandle[k] = item.handle; }
      mengeJe[k] += (item.quantity || 0);
    });

    var eintraege = [], maxLatest = null, maxLabel = '', unbekannt = false;
    reihenfolge.forEach(function(k){
      var pd = lz ? lz[idHandle[k]] : null;
      var vd = pd && pd.v ? pd.v[k] : null;
      if (!vd || !window.FGWirksameLieferzeit) { unbekannt = true; return; }
      var text = window.FGWirksameLieferzeit(vd, mengeJe[k], pd.kein, !!pd.flora).prop;
      var fd = window.FGZustellfensterDaten ? window.FGZustellfensterDaten(text) : null;
      if (!fd) { unbekannt = true; eintraege.push(k + '~' + text + '~'); return; }
      eintraege.push(k + '~' + text + '~' + fd.label);
      if (!maxLatest || fd.latest.getTime() > maxLatest.getTime()) { maxLatest = fd.latest; maxLabel = fd.label; }
    });

    return {
      eintraege: eintraege,
      unbekannt: unbekannt,
      attribute: {
        '_GesamtZustellfenster': (!unbekannt && maxLatest) ? maxLabel : '',
        '_Lieferzeiten': eintraege.join(' | ')
      }
    };
  }

  /* hintergrund = true: niemand wartet (Seitenaufruf, Aenderung im Warenkorb)
     -> lange Wartezeiten, bei fehlenden Daten spaeter noch einmal versuchen.
     Ohne: Klick auf "Zur Kasse" -> kurze Wartezeiten wie bisher. */
  var bgVersuche = 0;
  function syncCart(hintergrund){
    if (state.running) return state.running;

    var stampAtStart = currentStamp();
    var genAtStart = state.gen || 0;
    var sigAtStart = null;
    var unvollstaendig = false;
    var ms = hintergrund ? FG_BG_TIMEOUT_MS : FG_SYNC_TIMEOUT_MS;

    state.running = fetchWithTimeout('/cart.js', {}, ms)
      .then(function(r){ return r.json(); })
      .then(function(cart){
        sigAtStart = cartSig(cart);
        if (!cart || !cart.items || !cart.items.length) {
          return { attribute: { '_GesamtZustellfenster': '', '_Lieferzeiten': '', '_LZStand': '' }, alt: (cart && cart.attributes) || {} };
        }
        return ladeLieferzeitDaten(cart, hintergrund ? FG_BG_TIMEOUT_MS : FG_LZ_TIMEOUT_MS).then(function(lz){
          var r = lieferzeitenBerechnen(cart, lz);
          unvollstaendig = r.unbekannt;
          // Stand der Berechnung (Tag/Cutoff + Warenkorb-Inhalt). Daran erkennt die naechste Seite,
          // ob die Attribute noch stimmen, ohne neu zu rechnen. Unvollstaendig -> kein Stand,
          // dann rechnet die naechste Gelegenheit noch einmal.
          r.attribute._LZStand = unvollstaendig ? '' : stampAtStart + '|' + sigAtStart;
          r.alt = cart.attributes || {};
          return r;
        });
      })
      .then(function(r){
        var a = r.attribute;
        log('[FG Checkout Guard] Attribute →', a);
        // Nur schreiben, wenn sich etwas geaendert hat
        if ((r.alt._GesamtZustellfenster || '') === a._GesamtZustellfenster &&
            (r.alt._Lieferzeiten || '') === a._Lieferzeiten &&
            (r.alt._LZStand || '') === a._LZStand) return null;
        return fetchWithTimeout('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: a })
        }, ms);
      })
      .then(function(){
        state.syncedStamp = stampAtStart;
        state.syncedSig = sigAtStart;
        // Kam waehrend des Syncs eine Aenderung dazu, bleibt der Stand "dirty"
        state.dirty = ((state.gen || 0) !== genAtStart) || unvollstaendig;
        state.running = null;
        // Daten fehlten (z. B. Zeitueberschreitung): im Hintergrund bis zu 2x nachfassen
        if (unvollstaendig && bgVersuche < 2) {
          bgVersuche++;
          setTimeout(function(){ if (!state.running && !isFresh()) syncCart(true); }, 4000);
        } else if (!unvollstaendig) bgVersuche = 0;
        log('[FG Checkout Guard] Sync ok, Stempel:', stampAtStart);
      })
      .catch(function(err){
        // Fehlgeschlagener Sync darf den Checkout nicht blockieren.
        state.running = null;
        log('[FG Checkout Guard] Sync fehlgeschlagen:', err);
      });

    return state.running;
  }

  /* Fuer Tests in der Browser-Konsole: FGLieferzeitenTest() zeigt, was der
     Guard fuer den aktuellen Warenkorb schreiben wuerde (schreibt nichts). */
  window.FGLieferzeitenTest = function(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      return ladeLieferzeitDaten(cart).then(function(lz){ return lieferzeitenBerechnen(cart, lz); });
    });
  };

  function isFresh(){
    return !state.dirty && state.syncedStamp === currentStamp();
  }

  /* ---------------------------------------------------------------
     Warenkorb-Drawer beobachten: sobald er geöffnet wird, im
     Hintergrund synchronisieren. Der Kunde liest dann seinen
     Warenkorb - die ~1-2 Sekunden fallen nicht auf.
  --------------------------------------------------------------- */
  function watchDrawer(){
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer || !window.MutationObserver) return;
    var wasOpen = drawer.getAttribute('aria-hidden') === 'false';
    new MutationObserver(function(){
      var isOpen = drawer.getAttribute('aria-hidden') === 'false';
      if (isOpen && !wasOpen && !isFresh()) syncCart(true);
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  // Jede Warenkorbänderung macht die geschriebenen Werte angreifbar.
  // Ist der Warenkorb dabei offen (z. B. Cross-Sell im Drawer), sofort im
  // Hintergrund nachziehen - sonst fehlt beim direkten Klick auf "Zur Kasse"
  // das Zustellfenster an den neuen Positionen.
  /* FG 27.10.2026: nach JEDER Warenkorbaenderung im Hintergrund nachziehen,
     nicht nur bei offenem Warenkorb. Sonst musste der Guard erst beim Klick
     auf "Zur Kasse" rechnen und gab bei langsamer Verbindung nach 3 s auf
     (Bestellung 38937: Attribute vom Vortag). Schreibt nur Attribute. */
  var bgTimer = null;
  function scheduleBackgroundSync(){
    markDirty();
    clearTimeout(bgTimer);
    bgTimer = setTimeout(function(){
      (state.running || Promise.resolve()).then(function(){ if (!isFresh()) syncCart(true); });
    }, 700);
  }
  document.addEventListener('cart:refresh', scheduleBackgroundSync);
  document.addEventListener('cart:build', scheduleBackgroundSync);
  document.addEventListener('product:added', scheduleBackgroundSync);

  /* FG 27.10.2026: Beim Laden jeder Seite (nach dem Laden, im Hintergrund)
     pruefen, ob die gespeicherten Lieferzeiten noch zum Warenkorb und zum
     heutigen Tag passen (_LZStand). Passt es: nichts tun. Sonst nachrechnen.
     Leerer Warenkorb (laut Kopfzeile): gar keine Anfrage. */
  function ladePruefung(){
    if (window.location.pathname === '/cart') return;          // dort rechnet syncCart ohnehin beim Laden
    var zahl = document.querySelector('.Header__CartCount');
    if (zahl && (parseInt(zahl.textContent, 10) || 0) === 0) return;
    var genAtStart = state.gen || 0;
    fetchWithTimeout('/cart.js', {}, 2500)
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart || !cart.items || !cart.items.length) return;
        var stand = currentStamp() + '|' + cartSig(cart);
        if (cart.attributes && cart.attributes._LZStand === stand) {
          if ((state.gen || 0) === genAtStart && !state.running) {
            state.syncedStamp = currentStamp(); state.syncedSig = cartSig(cart); state.dirty = false;
          }
          return;
        }
        if (!state.running) syncCart(true);
      })
      .catch(function(err){ log('[FG Checkout Guard] Ladepruefung fehlgeschlagen:', err); });
  }
  if (document.readyState === 'complete') setTimeout(ladePruefung, 800);
  else window.addEventListener('load', function(){ setTimeout(ladePruefung, 800); });
  // Auf der /cart-Seite gibt es keinen Drawer -> dort direkt vorbereiten.
  if (window.location.pathname === '/cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ syncCart(true); });
    } else {
      syncCart(true);
    }
  }

  /* ---------------------------------------------------------------
     Button-Zustand
  --------------------------------------------------------------- */
  function setLoading(btn, on){
    if (!btn) return;
    if (on) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  function goToCheckout(){
    if (window.FG_isWholesaleCustomer && window.location.pathname !== '/cart') {
      window.location.href = '/cart';
    } else {
      window.location.href = '/checkout';
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest(
      'button[name="checkout"], ' +
      'button[data-checkout], ' +
      'a[href="/checkout"], ' +
      '[data-checkout-button], ' +
      '.FGCheckoutLink'
    );
    if (!btn) return;

    // Auf /cart: Wholesale-Kunden komplett WSH überlassen - kein Eingriff
    if (window.FG_isWholesaleCustomer && window.location.pathname === '/cart') return;

    e.preventDefault();

    // Doppelklick-Sperre: verhindert parallele Ketten auf denselben Line Items
    if (state.navigating) return;
    state.navigating = true;

    // Normalfall: beim Öffnen des Warenkorbs bereits geschrieben. Kurz pruefen,
    // ob der Warenkorb seitdem gleich geblieben ist (ein Lesezugriff, max.
    // FG_SIG_TIMEOUT_MS) - nur dann sofort weiter. Schlaegt die Pruefung fehl,
    // geht es trotzdem zur Kasse (wie bisher), der Checkout wird nie blockiert.
    if (isFresh()) {
      fetchWithTimeout('/cart.js', {}, FG_SIG_TIMEOUT_MS)
        .then(function(r){ return r.json(); })
        .then(function(cart){ return cartSig(cart) === state.syncedSig; })
        .catch(function(){ return true; })
        .then(function(gleich){
          if (gleich) {
            try { sessionStorage.setItem('fg_checkout_initiated', '1'); } catch(err){}
            goToCheckout();
          } else {
            markDirty();
            nachziehenUndWeiter(btn);
          }
        });
      return;
    }
    nachziehenUndWeiter(btn);
  });

  function nachziehenUndWeiter(btn){

    // Ausnahmefall (Warenkorb über Mitternacht/Mittag offen, Sync fehlgeschlagen):
    // nachziehen, aber in jedem Fall nach FG_SYNC_TIMEOUT_MS weiterleiten.
    setLoading(btn, true);

    var done = false;
    function proceed(){
      if (done) return;
      done = true;
      try { sessionStorage.setItem('fg_checkout_initiated', '1'); } catch(err){}
      goToCheckout();
      // Falls die Navigation blockiert wird, Button wieder freigeben
      setTimeout(function(){ setLoading(btn, false); state.navigating = false; }, 4000);
    }

    setTimeout(proceed, FG_CLICK_MAX_WAIT_MS);
    // Laeuft bereits ein Sync, erst dessen Ende abwarten und dann pruefen,
    // ob noch etwas offen ist (sonst kaeme nur das alte Promise zurueck).
    (state.running || Promise.resolve())
      .then(function(){ return isFresh() ? null : syncCart(); })
      .then(proceed, proceed);
  }

  /* ---------------------------------------------------------------
     Zentrale Add-to-Cart-Funktion fuer alle Wege ausserhalb des
     Hauptproduktformulars (Sticky-Button, Zubehoer-Box, Cross-Sell).
     Diese Wege umgehen das Formular und haben bisher weder
     _Anzeigename noch _Lieferzeit mitgeschickt - ohne _Lieferzeit
     vergibt der Guard auch kein Zustellfenster.

     opts.properties : bereits fertige Properties (Sticky liest sie
                       direkt aus dem Hauptformular)
     opts.anzeigename: product.metafields.custom.anzeigename
     opts.lieferzeit,
     opts.inventory  : seit 26.10.2026 ohne Wirkung - die Lieferzeit
                       bestimmt der Checkout-Guard fuer den ganzen
                       Warenkorb (Attribut _Lieferzeiten). Aufrufer
                       duerfen sie weiter mitgeben.
  --------------------------------------------------------------- */
  /* Properties aus den Optionen bauen - fuer FGAddToCart und die
     Sammelvariante darunter dieselbe Regel. */
  function fgProps(opts, qty){
    opts = opts || {};
    var props = {};
    if (opts.properties) {
      for (var k in opts.properties) {
        if (Object.prototype.hasOwnProperty.call(opts.properties, k)) props[k] = opts.properties[k];
      }
    }
    if (opts.anzeigename) props._Anzeigename = opts.anzeigename;
    /* FG 26.10.2026: Lieferzeit und Zustellfenster kommen NICHT mehr in die
       Zeile - sie stehen als Warenkorb-Attribut (_Lieferzeiten), das der
       Checkout-Guard schreibt. Was ein Aufrufer noch mitgibt (opts.lieferzeit
       oder Properties aus dem Produktformular), wird hier bewusst verworfen,
       damit gleiche Artikel immer in derselben Zeile landen. */
    delete props._Lieferzeit;
    delete props._Zustellfenster;
    return props;
  }

  /* ---------------------------------------------------------------
     Mehrere Positionen in EINEM Request. /cart/add.js nimmt ein
     items-Array; die Einzelfunktion darunter kann das nicht, weil sie
     auf genau eine Variante gebaut ist.

     Wer sie nacheinander aufruft, wartet pro Position eine volle
     Netzrunde: vier Artikel aus der Schritte-Zone brauchten so rund
     eine Sekunde, in der sichtbar nichts passiert. Als ein Request ist
     es eine Runde.

     markDirty() laeuft einmal - der Guard interessiert sich dafuer,
     DASS der Warenkorb sich geaendert hat, nicht wie oft.

     items: [{ id, quantity, opts }] - opts wie bei FGAddToCart.
  --------------------------------------------------------------- */
  window.FGAddToCartMulti = function(items){
    var liste = (items || []).filter(function(it){ return it && it.id; });
    if (!liste.length) return Promise.resolve(null);

    var payload = { items: liste.map(function(it){
      var qty = Math.max(1, parseInt(it.quantity, 10) || 1);
      var eintrag = { id: Number(it.id), quantity: qty };
      var props = fgProps(it.opts, qty);
      if (Object.keys(props).length) eintrag.properties = props;
      return eintrag;
    }) };

    markDirty();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (!r.ok) return r.json().catch(function(){ return {}; }).then(function(body){
        var msg = body.description || body.message || ('add.js HTTP ' + r.status);
        throw new Error(msg);
      });
      scheduleBackgroundSync();
      return r.json();
    });
  };

  window.FGAddToCart = function(id, quantity, opts){
    /* Properties baut fgProps (siehe oben) - gleiche Regel wie in der
       Sammelvariante. Das Praefix "Lieferzeit:" faellt dort weg, und das
       Zustellfenster bleibt leer: der Guard berechnet es beim Oeffnen des
       Warenkorbs neu, damit kein veraltetes Datum haengen bleibt. */
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    var props = fgProps(opts, qty);

    var payload = { id: id, quantity: qty };
    if (Object.keys(props).length) payload.properties = props;

    markDirty();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (!r.ok) return r.json().catch(function(){ return {}; }).then(function(body){
        var msg = body.description || body.message || ('add.js HTTP ' + r.status);
        throw new Error(msg);
      });
      scheduleBackgroundSync();
      return r.json();
    });
  };

  /* Sucht eine Zubehoer-/Cross-Sell-Variante in den globalen Maps, die
     die Karussell-Snippets aus Liquid aufbauen, und liefert die Felder
     fuer FGAddToCart zurueck. Die Maps sind nach der Variant-ID des
     HAUPTprodukts indiziert, gesucht wird aber die ID des Zubehoers -
     deshalb ueber alle Eintraege. */
  window.FGLookupItem = function(id){
    var wanted = Number(id);
    var out = null;

    function take(entry){
      if (!entry || Number(entry.id) !== wanted) return false;
      out = {
        anzeigename: entry.anzeigename || '',
        lieferzeit:  entry.lieferzeit  || '',
        inventory:   (entry.inventory === undefined ? null : entry.inventory)
      };
      return true;
    }

    var listMaps = [window.variantAccessoriesListMap, window.variantCrossSellListMap];
    for (var m = 0; m < listMaps.length && !out; m++) {
      var map = listMaps[m];
      if (!map) continue;
      for (var key in map) {
        if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
        var list = map[key] || [];
        for (var i = 0; i < list.length; i++) { if (take(list[i])) break; }
        if (out) break;
      }
    }

    if (!out && window.variantInlayMap) {
      for (var k in window.variantInlayMap) {
        if (!Object.prototype.hasOwnProperty.call(window.variantInlayMap, k)) continue;
        if (take(window.variantInlayMap[k])) break;
      }
    }

    return out || {};
  };

  /* Properties aus dem Hauptproduktformular uebernehmen - dort stehen
     _Anzeigename (hidden input) und _Lieferzeit (von shipping-profile.liquid
     gesetzt) bereits korrekt und variantengenau. */
  window.FGPropsFromProductForm = function(){
    var props = {};
    var form = document.querySelector('.ProductForm');
    if (!form) return props;
    var inputs = form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
    for (var i = 0; i < inputs.length; i++) {
      var m = inputs[i].name.match(/^properties\[(.+)\]$/);
      if (!m) continue;
      if (inputs[i].type === 'checkbox' && !inputs[i].checked) continue;
      if (m[1] === '_Lieferzeit' || m[1] === '_Zustellfenster') continue; // FG 26.10.: nur noch Warenkorb-Attribut
      if (inputs[i].value !== '') props[m[1]] = inputs[i].value;
    }
    return props;
  };

  /* Zurueck vom Checkout: Navigation freigeben und beim naechsten Oeffnen
     neu rechnen. Bis 26.10.2026 wurde hier zusaetzlich _Zustellfenster in
     allen Zeilen per change.js geleert - das schrieb in die Zeilen, waehrend
     der Kunde schon wieder Mengen aendern konnte. Mit den Attributen ist das
     nicht mehr noetig. */
  window.addEventListener('pageshow', function(e){
    state.navigating = false;
    var fromBack = e.persisted || (window.performance && window.performance.navigation && window.performance.navigation.type === 2);
    var initiated = false;
    try { initiated = sessionStorage.getItem('fg_checkout_initiated') === '1'; } catch(err){}
    if (!fromBack && !initiated) return;
    try { sessionStorage.removeItem('fg_checkout_initiated'); } catch(err){}
    markDirty();
  });
})();

/* =====================================================
   Mengenstaffel / Quantity Breaks v2
   =====================================================
   Voraussetzung: Produkt-Metafeld custom.quantity_breaks (Typ: JSON)
   Beispiel: [{"qty":2,"discount":10,"label":"Beliebt"},{"qty":4,"discount":15,"label":"Größte Ersparnis"}]

   Änderungen
   - Kompaktes Ein-Zeilen-Layout (flex-wrap: nowrap)
   - Eigene Menge direkt in die aktive Karte integriert (+/- Controls)
   - Tier-Logik: Menge 3 bekommt den Rabatt der Stufe ab 2, Menge 5 den Rabatt ab 4 usw.
   - Beim Überschreiten einer Tier-Grenze springt die Kartenauswahl automatisch
   ===================================================== */
(function () {
  'use strict';

  /* --------------------------------------------------
     CSS-Injektion
  -------------------------------------------------- */
  function injectStyles() {
    if (document.getElementById('fg-qty-breaks-styles')) return;
    var s = document.createElement('style');
    s.id = 'fg-qty-breaks-styles';
    s.textContent = [
      /* Container: eine Zeile */
      '.fg-qty-breaks{display:flex;flex-wrap:nowrap;gap:6px;margin:0 0 14px;align-items:stretch;}',

      /* Karte – Basis */
      '.fg-qty-card{',
        'flex:1 1 0%;min-width:0;',
        'padding:7px 9px;border:2px solid #ddd;border-radius:8px;',
        'background:#fff;cursor:pointer;text-align:center;',
        'font-family:inherit;font-size:12px;line-height:1.35;',
        'transition:border-color .15s,background .15s;',
        'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;',
        'outline:none;',
      '}',
      '.fg-qty-card:hover{border-color:#3fae58;background:#f5fdf7;}',

      /* Aktive Karte (div, kein button) */
      '.fg-qty-card.is-selected{border-color:#3fae58;background:#edf9f0;cursor:default;}',

      /* Textelemente */
      '.fg-qty-card__qty-label{font-weight:700;font-size:13px;color:#1a1a1a;}',

      /* Badge */
      '.fg-qty-card__badge{',
        'display:inline-block;background:#3fae58;color:#fff;',
        'font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;',
        'padding:1px 5px;border-radius:3px;',
      '}',

      /* Preiszeilen */
      '.fg-qty-card__price{font-size:12px;color:#555;}',
      '.fg-qty-card__discounted{font-size:13px;font-weight:700;color:#3fae58;}',
      '.fg-qty-card__price-row{display:flex;align-items:center;justify-content:center;gap:5px;}',
      '.fg-qty-card__regular{font-size:11px;color:#777;text-decoration:line-through;}',
      '.fg-qty-card__saving{font-size:11px;color:#3fae58;}',

      /* +/- Controls (nur in aktiver Karte) */
      '.fg-qty-card__controls{display:flex;align-items:center;gap:4px;margin:1px 0;}',
      '.fg-qty-card__qty-number{font-weight:700;font-size:13px;min-width:50px;text-align:center;}',
      '.fg-qty-btn{',
        'flex-shrink:0;width:24px;height:24px;',
        'border:1px solid #bbb;border-radius:4px;',
        'background:#f3f3f3;cursor:pointer;',
        'font-size:16px;line-height:1;',
        'display:flex;align-items:center;justify-content:center;',
        'padding:0;font-family:inherit;',
        'transition:background .1s;',
      '}',
      '.fg-qty-btn:hover:not([disabled]){background:#e2e2e2;}',
      '.fg-qty-btn[disabled]{opacity:.35;cursor:not-allowed;}',

      /* Mobile: 2-Spalten-Wrap */
      '@media(max-width:560px){',
        '.fg-qty-breaks{flex-wrap:wrap;}',
        '.fg-qty-card{flex:1 1 calc(50% - 3px);}',
      '}',
    ].join('');
    document.head.appendChild(s);
  }

  /* --------------------------------------------------
     State
  -------------------------------------------------- */
  var state = {
    breaks: null,                 // Array aus Metafeld, z.B. [{qty:2,discount:10,label:'Beliebt'}, ...]
    currentQty: 1,                // Aktuell gewählte Menge
    currentPlantVariantId: null   // Wird bei variant:changed aktualisiert
  };

  /* --------------------------------------------------
     Tier-Logik

     Aus dem breaks-Array werden Stufen berechnet:
       Tier 0:  minQty=1,             maxQty=breaks[0].qty-1,   discount=0
       Tier 1:  minQty=breaks[0].qty, maxQty=breaks[1].qty-1,   discount=breaks[0].discount
       Tier 2:  minQty=breaks[1].qty, maxQty=∞,                 discount=breaks[1].discount
       ...

     Beispiel breaks=[{qty:2,disc:10},{qty:4,disc:15}]:
       Tier 0: 1 Stück     → 0%  Rabatt
       Tier 1: 2–3 Stück   → 10% Rabatt
       Tier 2: ab 4 Stück  → 15% Rabatt
  -------------------------------------------------- */
  function getTiers() {
    var tiers = [{
      minQty:   1,
      maxQty:   state.breaks.length > 0 ? (parseInt(state.breaks[0].qty) - 1) : Infinity,
      discount: 0,
      label:    ''
    }];
    for (var i = 0; i < state.breaks.length; i++) {
      var nextMin = (i + 1 < state.breaks.length) ? parseInt(state.breaks[i + 1].qty) : Infinity;
      tiers.push({
        minQty:   parseInt(state.breaks[i].qty),
        maxQty:   nextMin === Infinity ? Infinity : (nextMin - 1),
        discount: parseFloat(state.breaks[i].discount) || 0,
        label:    (state.breaks[i].label || '').toString().trim()
      });
    }
    return tiers;
  }

  /**
   * Gibt den Index des zutreffenden Tiers für eine Menge zurück.
   * qty=3 bei breaks [2,4] → Tier 1 (10% ab 2 Stück)
   * qty=5 bei breaks [2,4] → Tier 2 (15% ab 4 Stück)
   */
  function getActiveTierIndex(qty) {
    var tiers = getTiers();
    var idx = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].minQty) idx = i;
    }
    return idx;
  }

  /* --------------------------------------------------
     Preislogik
  -------------------------------------------------- */
  function isKonfigurator() {
    return !!document.querySelector('[data-is-konfigurator]');
  }

  /**
   * Pflanzenpreis in Cent.
   * Liest aus demselben Ort wie bhgl.min.js: jQuery-Data-Cache auf [data-pricecalc-plant].
   */
  function getPlantPriceCents() {
    var el = document.querySelector('[data-pricecalc-plant]');
    if (!el) return 0;
    if (window.jQuery) {
      var jqVal = jQuery(el).data('pricecalc-plant');
      if (jqVal !== undefined && !isNaN(parseInt(jqVal))) return parseInt(jqVal);
    }
    var varId = state.currentPlantVariantId || el.value;
    if (varId && window.FG_VARIANTS && window.FG_PRODUCT_ID) {
      var row = (window.FG_VARIANTS[window.FG_PRODUCT_ID] || {})[String(varId)];
      if (row && typeof row.price === 'number') return row.price;
    }
    return parseInt(el.getAttribute('data-pricecalc-plant')) || 0;
  }

  function getPotPriceCents() {
    var el = document.querySelector('[data-pricecalc-pot]');
    return el ? (parseInt(el.getAttribute('data-pricecalc-pot')) || 0) : 0;
  }

  function getInlayPriceCents() {
    var checkbox = document.querySelector('[data-select-inlay]');
    if (!checkbox || !checkbox.checked) return 0;
    var el = document.querySelector('[data-pricecalc-inlay]');
    return el ? (parseInt(el.getAttribute('data-pricecalc-inlay')) || 0) : 0;
  }

    /* Compare-/Streichpreise – spiegeln data-comparepricecalc-* wider,
     die bhgl.min.js analog zu den aktuellen Preisen befüllt.          */
  function getPlantComparePriceCents() {
    var el = document.querySelector('[data-comparepricecalc-plant]');
    if (el) {
      if (window.jQuery) {
        var jqVal = jQuery(el).data('comparepricecalc-plant');
        if (jqVal !== undefined && !isNaN(parseInt(jqVal))) return parseInt(jqVal);
      }
      var attrVal = parseInt(el.getAttribute('data-comparepricecalc-plant')) || 0;
      if (attrVal > 0) return attrVal;
    }
    // Fallback: FG_VARIANTS – wichtig bei Variantenwechsel auf normalen Produktseiten
    var varId = state.currentPlantVariantId;
    if (!varId && el) varId = el.value;
    if (varId && window.FG_VARIANTS && window.FG_PRODUCT_ID) {
      var row = (window.FG_VARIANTS[window.FG_PRODUCT_ID] || {})[String(varId)];
      if (row && typeof row.compare_at_price === 'number') return row.compare_at_price;
    }
    return 0;
  }


  function getPotComparePriceCents() {
    var el = document.querySelector('[data-comparepricecalc-pot]');
    return el ? (parseInt(el.getAttribute('data-comparepricecalc-pot')) || 0) : 0;
  }

  function getInlayComparePriceCents() {
    var checkbox = document.querySelector('[data-select-inlay]');
    if (!checkbox || !checkbox.checked) return 0;
    var el = document.querySelector('[data-comparepricecalc-inlay]');
    return el ? (parseInt(el.getAttribute('data-comparepricecalc-inlay')) || 0) : 0;
  }


  function getCurrentUnitPriceCents() {
    if (isKonfigurator()) {
      return getPlantPriceCents() + getPotPriceCents() + getInlayPriceCents();
    }
    var varId = state.currentPlantVariantId;
    if (!varId) {
      var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      varId = idInput ? idInput.value : null;
    }
    if (varId && window.FG_VARIANTS && window.FG_PRODUCT_ID) {
      var row = (window.FG_VARIANTS[window.FG_PRODUCT_ID] || {})[String(varId)];
      if (row && typeof row.price === 'number') return row.price;
    }
    return 0;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '\u00a0\u20ac';
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* --------------------------------------------------
     Preisberechnung für eine Karte
  -------------------------------------------------- */
  /**
   * Korrekte Preisberechnung mit Streichpreis-Basis und Split-Rabatt-Logik.
   *
   * Basis (regularUnit) = Streichpreise aller Komponenten.
   * Falls kein Streichpreis vorhanden: aktueller Preis wird als Basis verwendet.
   *
   * Mengenrabatt:
   *   - Pflanze:  immer
   *   - Topf:     nur wenn NICHT bereits im Sale
   *   - Einsatz:  nur wenn NICHT bereits im Sale
   *
   * Bei discount=0 (1 Stück): Zeigt trotzdem bestehende Ersparnis an,
   * falls Pflanze oder Topf bereits reduziert sind.
   */
  function calcPrices(qty, discount) {
    var plantPrice  = getPlantPriceCents();
    var potPrice    = getPotPriceCents();
    var inlayPrice  = getInlayPriceCents();

    // Streichpreise – mindestens so hoch wie der aktuelle Preis
    var plantRef  = Math.max(getPlantComparePriceCents(),  plantPrice);
    var potRef    = Math.max(getPotComparePriceCents(),    potPrice);
    var inlayRef  = Math.max(getInlayComparePriceCents(),  inlayPrice);

    // Ist Topf / Einsatz bereits reduziert?
    var potOnSale   = potRef   > potPrice;
    var inlayOnSale = inlayRef > inlayPrice;

    // Effektive Preise nach Mengenrabatt
    var d = discount / 100;
    var discPlant, discPot, discInlay;

    if (isKonfigurator()) {
      // Konfigurator: Pflanze bekommt immer Mengenrabatt (auch wenn im Sale)
      // Topf / Einsatz: nur wenn NICHT bereits reduziert
      discPlant = discount > 0 ? Math.round(plantPrice * (1 - d)) : plantPrice;
      discPot   = (discount > 0 && !potOnSale)   ? Math.round(potPrice   * (1 - d)) : potPrice;
      discInlay = (discount > 0 && !inlayOnSale) ? Math.round(inlayPrice * (1 - d)) : inlayPrice;
    } else {
      // Normales Produkt: kein Mengenrabatt wenn Variante bereits reduziert ist
      // (Shopify Automatischer Rabatt greift in diesem Fall nicht)
      var plantOnSale = plantRef > plantPrice;
      discPlant = (discount > 0 && !plantOnSale) ? Math.round(plantPrice * (1 - d)) : plantPrice;
      discPot   = 0;
      discInlay = 0;
    }

    var regularUnit    = plantRef + potRef + inlayRef;
    var discountedUnit = discPlant + discPot + discInlay;
    var savingUnit     = regularUnit - discountedUnit;
    var effectivePct   = regularUnit > 0 ? Math.round(savingUnit / regularUnit * 100) : 0;

    return {
      regular:     regularUnit    * qty,
      discounted:  discountedUnit * qty,
      saving:      savingUnit     * qty,
      effectivePct: effectivePct
    };
  }


  function buildPriceHtml(prices) {
    if (prices.regular <= 0) return '';
    if (prices.saving > 0 && prices.effectivePct > 0) {
      return '<span class="fg-qty-card__price-row">' +
               '<span class="fg-qty-card__discounted">' + formatMoney(prices.discounted) + '</span>' +
               '<span class="fg-qty-card__regular">' + formatMoney(prices.regular) + '</span>' +
             '</span>' +
             '<span class="fg-qty-card__saving">\u2212' + prices.effectivePct + '%\u00a0\u00b7\u00a0Du\u00a0sparst\u00a0' + formatMoney(prices.saving) + '</span>';
    }
    return '<span class="fg-qty-card__price">' + formatMoney(prices.regular) + '</span>';
  }


  /* --------------------------------------------------
     Rendering
  -------------------------------------------------- */
  var renderDebounceTimer = null;
  function renderBreaksDebounced() {
    clearTimeout(renderDebounceTimer);
    renderDebounceTimer = setTimeout(renderBreaks, 60);
  }

  function renderBreaks() {
    var container = document.getElementById('fg-quantity-breaks');
    if (!container || !state.breaks) return;

    var tiers        = getTiers();
    var activeTierIdx = getActiveTierIndex(state.currentQty);

    var html = '<div class="fg-qty-breaks">';
    for (var i = 0; i < tiers.length; i++) {
      html += buildCard(tiers[i], i === activeTierIdx);
    }
    html += '</div>';

    container.innerHTML = html;
    bindCardEvents(container);
  }

  /**
   * Baut eine Mengenkarte.
   *
   * Inaktive Karte (button):
   *   - Zeigt die Mindestmenge des Tiers
   *   - Badge (wenn vorhanden)
   *   - Preis / Ersparnis für die Mindestmenge
   *   - Klick → wählt den Tier mit seiner Mindestmenge
   *
   * Aktive Karte (div):
   *   - Zeigt die tatsächlich gewählte Menge mit [−] und [+]
   *   - Rabatt des aktuellen Tiers gilt für die tatsächliche Menge
   *   - [+] kann über die Tier-Grenze hinaus gehen → nächste Karte wird aktiv
   *   - [−] kann unter die Tier-Grenze gehen → vorherige Karte wird aktiv
   */
  function buildCard(tier, isSelected) {
    var badgeHtml = tier.label ? '<span class="fg-qty-card__badge">' + escHtml(tier.label) + '</span>' : '';

    if (isSelected) {
      var qty    = state.currentQty;
      var prices = calcPrices(qty, tier.discount);
      return (
        '<div class="fg-qty-card is-selected">' +
          badgeHtml +
          '<span class="fg-qty-card__controls">' +
            '<button type="button" class="fg-qty-btn" data-fg-qty-minus' +
              (qty <= 1 ? ' disabled' : '') + '>\u2212</button>' +
            '<span class="fg-qty-card__qty-number">' + qty + '\u00a0St\u00fcck</span>' +
            '<button type="button" class="fg-qty-btn" data-fg-qty-plus>+</button>' +
          '</span>' +
          buildPriceHtml(prices) +
        '</div>'
      );
    }

    /* Inaktive Karte: zeigt Mindestmenge des Tiers */
    var minQty    = tier.minQty;
    var prices = calcPrices(minQty, tier.discount);
    return (
      '<button type="button" class="fg-qty-card" data-fg-qty-card data-fg-qty="' + minQty + '">' +
        '<span class="fg-qty-card__qty-label">' + minQty + '\u00a0St\u00fcck</span>' +
        badgeHtml +
        buildPriceHtml(prices) +
      '</button>'
    );
  }

  /* --------------------------------------------------
     Event-Binding
  -------------------------------------------------- */
  function bindCardEvents(container) {
    /* Inaktive Karten: Klick setzt Menge auf Tier-Minimum */
    var cards = container.querySelectorAll('[data-fg-qty-card]');
    for (var i = 0; i < cards.length; i++) {
      cards[i].addEventListener('click', handleFixedCardClick);
    }

    /* Minus-Button */
    var minusBtn = container.querySelector('[data-fg-qty-minus]');
    if (minusBtn) minusBtn.addEventListener('click', handleMinusClick);

    /* Plus-Button */
    var plusBtn = container.querySelector('[data-fg-qty-plus]');
    if (plusBtn) plusBtn.addEventListener('click', handlePlusClick);
  }

  function handleFixedCardClick() {
    var qty = parseInt(this.getAttribute('data-fg-qty'));
    if (isNaN(qty) || qty < 1) return;
    state.currentQty = qty;
    setQtyInput(qty);
    renderBreaks();
  }

  function handleMinusClick(e) {
    e.stopPropagation();
    if (state.currentQty <= 1) return;
    state.currentQty--;
    setQtyInput(state.currentQty);
    renderBreaks();
  }

  function handlePlusClick(e) {
    e.stopPropagation();
    state.currentQty++;
    setQtyInput(state.currentQty);
    renderBreaks();
  }

  /**
   * Setzt [name="quantity"] – das Formularfeld, das beim Add-to-Cart
   * sowohl beim Standard-Submit als auch beim Konfigurator-Ajax gelesen wird.
   */
  function setQtyInput(qty) {
    var input = document.querySelector('[name="quantity"]');
    if (!input) return;
    input.value = String(qty);
    try { input.dispatchEvent(new Event('change', {bubbles: true})); } catch (e) {}
  }

  /* --------------------------------------------------
     Preisbeobachter:
     Reagiert auf Topf-Wechsel, Einsatz-Wechsel, Variantenwechsel
  -------------------------------------------------- */
  function attachObservers() {
    /* 1) MutationObserver auf [data-display-sum]
          bhgl.min.js schreibt den Konfigurator-Gesamtpreis hierher.
          Wenn Topf oder Einsatz wechselt, re-rendern wir die Karten. */
    var displaySums = document.querySelectorAll('[data-display-sum]');
    for (var i = 0; i < displaySums.length; i++) {
      (function (el) {
        var obs = new MutationObserver(renderBreaksDebounced);
        obs.observe(el, {childList: true, characterData: true, subtree: true});
      })(displaySums[i]);
    }

    /* 2) Varianten-Wechsel (Pflanzengröße, Farbe etc.) */
    ['variant:changed', 'variant:change', 'product:variant-change'].forEach(function (evName) {
      document.addEventListener(evName, function (e) {
        if (e && e.detail && e.detail.variant && e.detail.variant.id) {
          state.currentPlantVariantId = String(e.detail.variant.id);
        }
        renderBreaksDebounced();
      });
    });

    /* 3) Topf- und Einsatz-Auswahl */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var relevant =
        (t.name === 'pot') ||
        !!(t.closest && t.closest('[data-upsellproduct]')) ||
        !!(t.closest && t.closest('[data-upsell-variant]')) ||
        !!(t.matches && t.matches('[data-select-inlay]'));
      if (relevant) renderBreaksDebounced();
    });

    /* 4) Tab-Wechsel (Classic / Modern / Elegant / Boho) */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-tab-control]')) {
        renderBreaksDebounced();
      }
    });
  }

  /* --------------------------------------------------
     Initialisierung
  -------------------------------------------------- */
  function init() {
    var dataEl = document.getElementById('fg-quantity-breaks-data');
    if (!dataEl) return; /* Kein Metafeld → Standard-QuantitySelector bleibt */

    var raw = (dataEl.textContent || '').trim();
    var breaks;
    try {
      breaks = JSON.parse(raw);
    } catch (e) {
      console.warn('[FG QtyBreaks] Ungültiges JSON im Metafeld custom.quantity_breaks:', e);
      return;
    }
    if (!Array.isArray(breaks) || breaks.length === 0) return;

    state.breaks = breaks;

    /* Standard-QuantitySelector ausblenden.
       [name="quantity"] bleibt im DOM und in der Formular-Submission aktiv. */
    var standardQS = document.querySelector('.ProductForm__QuantitySelector');
    if (standardQS) standardQS.style.display = 'none';

    injectStyles();
    attachObservers();
    renderBreaks();

    /* Zweiter Render nach 300ms sichert korrekte Topfpreise,
       falls bhgl.min.js noch nicht fertig war beim ersten Render. */
    setTimeout(renderBreaks, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(); /* Ende Mengenstaffel */

// Kollektion-Badges
/* Mengenrabatt-Badge Variante B - Inhalt (auch von boost-pfs-filter.js genutzt) und Gestaltung.
   Weiss mit gruenem Rand, damit es sich vom mintfarbenen Sale-Badge unterscheidet. */
window.fgQtyBadgeInhalt = function (breaks) {
  var max = 0, stufen = 0, erste = null;
  (breaks || []).forEach(function (b) {
    var d = Math.round(parseFloat(b.discount) || 0);
    if (d > 0) { stufen++; if (!erste) erste = { d: d, q: b.qty }; if (d > max) max = d; }
  });
  if (!stufen) return '';
  var rest = stufen > 1 ? 'bis -' + max + '%' : '-' + erste.d + '% ab ' + erste.q + ' Stk.';
  return '<div class="fg-qty-badge">Mengenrabatt <span>' + rest + '</span></div>';
};
(function () {
  if (document.getElementById('fg-qty-eins-stil')) return;
  var st = document.createElement('style'); st.id = 'fg-qty-eins-stil';
  st.textContent =
    '.fg-qty-badge-group.fg-qty-eins{top:8px;right:8px}' +
    '.fg-qty-eins .fg-qty-badge{background:rgba(255,255,255,.94);color:#1f4d36;border:1px solid #cfe3d6;border-radius:5px;font-size:12px;font-weight:700;line-height:1.2;padding:6px 9px}' +
    '.fg-qty-eins .fg-qty-badge span{font-weight:500;color:#4d6b5a}' +
    '@media screen and (max-width:767px){.fg-qty-badge-group.fg-qty-eins{top:6px;right:6px}.fg-qty-eins .fg-qty-badge{font-size:10px;padding:4px 6px}}';
  (document.head || document.documentElement).appendChild(st);
})();
window.fgInitCollectionBadges = function () {
  document.querySelectorAll('.fg-qty-badge[data-qty-breaks]').forEach(function (el) {
    if (el.textContent.trim()) return; // bereits befüllt
    // Sale-Produkte überspringen: hc-sale-tag ist im gleichen Wrapper vorhanden
    var wrapper = el.closest('.ProductItem__Wrapper');
    if (wrapper && wrapper.querySelector('.hc-sale-tag')) return;
    try {
      var breaks = JSON.parse(el.getAttribute('data-qty-breaks'));
      if (!Array.isArray(breaks) || !breaks.length) return;
      breaks.sort(function (a, b) { return (a.qty || 0) - (b.qty || 0); });
/* ein Badge "Mengenrabatt bis -15%" statt einer Zeile je Stufe.
   Bei nur einer Stufe: "Mengenrabatt -10% ab 2 Stk.". Gleiche Logik in assets/boost-pfs-filter.js. */
var items = window.fgQtyBadgeInhalt(breaks);
if (!items) return;
el.className = 'fg-qty-badge-group fg-qty-eins';
el.removeAttribute('data-qty-breaks');
el.innerHTML = items;

    } catch (e) {}
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.fgInitCollectionBadges);
} else {
  window.fgInitCollectionBadges();
}

/* =========================================================================
   Produktgalerie ab 1008 px: Thumbnails stehen neben dem Bild (CSS in
   snippets/inline_styles.liquid). Hier nur das, was Rechnen erfordert:

   - Die Thumbnail-Leiste ist genauso hoch wie das Bild. Was nicht mehr
     hineinpasst, steht als "+3" auf dem letzten sichtbaren Thumbnail.
     Die Plakette ist reine Anzeige; dieses Thumbnail ist nicht anklickbar.
   - Ist das Bild hoeher als das Fenster, faellt das sticky der Galerie weg -
     sonst bliebe der untere Bildrand dauerhaft unter dem Fensterrand.
   - Nach jedem Variantenwechsel muss Flickity neu vermessen werden. Wichtig
     ist dabei die Reihenfolge reloadCells -> resize -> select: ohne das
     abschliessende select zeigt Flickity zwar einen neuen Index an, schiebt
     den Schieber aber nicht mit (selectedSlide bleibt auf dem alten, nicht
     mehr existierenden Slide stehen). Genau daran sind die Pfeile nach einem
     Groessenwechsel ins Leere gelaufen.
   - Gezaehlt werden nur Thumbnails, die der Varianten-Bildfilter uebrig
     laesst (VariantFilter--hidden).
   ========================================================================= */
(function(){
  var MIN = 1008;
  var versuche = 0;   /* begrenzt das Warten auf eine laufende Bewegung */

  function teile(){
    /* Product--fgGalerie vergibt sections/main-product.liquid nur fuer Vorlagen
       ohne Bilderstapel und ohne Konfigurator - genau dort gilt das Layout. */
    var gal = document.querySelector('.Product--fgGalerie .Product__Gallery--withThumbnails');
    if (!gal) return null;
    var nav  = gal.querySelector('.Product__SlideshowNav--thumbnails');
    var show = gal.querySelector('.Product__Slideshow');
    if (!nav || !show) return null;
    return { gal: gal, nav: nav, sc: nav.querySelector('.Product__SlideshowNavScroller') || nav, show: show };
  }

  function flick(){
    var s = document.querySelector('.Product--fgGalerie .Product__Slideshow');
    return (s && window.Flickity && window.Flickity.data(s)) || null;
  }

  /* Das Theme blendet nach jedem Bildwechsel alle Folien ausser der aktiven aus
     (_onImageSettled setzt Product__SlideItem--hidden auf alles, was nicht
     .is-selected traegt). Passt die aktive Folie einmal nicht zur Position des
     Schiebers, steht die ganze Galerie leer da. Diese Zeile stellt sicher, dass
     die gerade gezeigte Folie immer sichtbar bleibt. */
  function aufraeumen(f){
    if (!f) return;
    var e = f.selectedCell && f.selectedCell.element;
    if (e) e.classList.remove('Product__SlideItem--hidden');
    /* Zweite Absicherung: sind Schieber und aktive Folie auseinandergelaufen
       (kommt vor, wenn eine Bewegung unterbrochen wurde oder sich die
       Folienliste mittendrin geaendert hat), zeigt der Rahmen ins Nichts.
       Dann hart nachziehen. */
    if (f.selectedSlide && !f.isAnimating && !f.isDragging &&
        Math.abs(f.x + f.selectedSlide.target) > 2){
      try { f.select(f.selectedIndex, false, true); } catch(err){}
    }
  }

  /* Klick auf ein Thumbnail: das Theme waehlt ueber data-media-position, also
     ueber die Position in ALLEN Medien des Produkts. Der Varianten-Bildfilter
     laesst davon nur einen Teil als Folien uebrig - dadurch landete ein Klick
     auf das zweite Thumbnail beim letzten Bild, und die mittleren Thumbnails
     reagierten gar nicht (die Position lag ausserhalb der Folienliste).
     Wir waehlen deshalb selbst, ueber die Medien-ID. */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('.Product__SlideshowNavImage') : null;
    if (!a || !a.closest('.Product--fgGalerie')) return;
    var f = flick();
    if (!f || !f.cells) return;
    var ziel = -1, i;
    if (a.hasAttribute('data-fg-konfi')){
      /* Konfigurator-Folie: hat keine Medien-ID, wird ueber den Typ gefunden.
         Bewusst nicht ueber Index 0 - falls die Folienreihenfolge sich einmal
         aendert, stimmt der Typ weiterhin. */
      for (i = 0; i < f.cells.length; i++){
        if (f.cells[i].element.getAttribute('data-media-type') === 'konfigurator'){ ziel = i; break; }
      }
    } else {
      var id = a.getAttribute('data-media-id');
      for (i = 0; i < f.cells.length; i++){
        if (f.cells[i].element.getAttribute('data-media-id') === id){ ziel = i; break; }
      }
    }
    if (ziel < 0) return;
    e.preventDefault();
    e.stopPropagation();
    f.select(ziel);
    aufraeumen(f);
    konfiMarkieren(f);
  }, true);

  function sichtbare(t){
    return [].slice.call(t.sc.querySelectorAll('.Product__SlideshowNavImage'))
      .filter(function(a){ return !a.classList.contains('VariantFilter--hidden'); });
  }

  /* Flickity merkt sich Zellgroessen, Zielpositionen und die aktive Folie.
     Aendert sich der Zuschnitt oder faellt eine Folie weg, muss alles drei neu
     gesetzt werden - resize() allein reicht nicht. */
  function neuVermessen(hart){
    var f = flick();
    if (!f) return;
    /* Waehrend einer laufenden Bewegung steigt Flickitys resize() selbst aus
       (interne Sperre gegen iOS-Ruckler). reloadCells() liefe trotzdem durch -
       die Zellen haetten dann neue Positionen, der Schieber noch die alten,
       und die Galerie stuende leer da. Deshalb erst abwarten. */
    if ((f.isAnimating || f.isDragging) && versuche < 8){
      versuche++;
      setTimeout(function(){ neuVermessen(hart); aktualisieren(); }, 250);
      return;
    }
    /* Nach acht vergeblichen Anlaeufen (etwa zwei Sekunden) trotzdem messen -
       lieber ein kurzes Zucken als eine Galerie, die leer stehen bleibt. */
    versuche = 0;
    try {
      /* Ohne cellSelector nimmt reloadCells() ALLE Kindelemente als Folien -
         auch die, die der Varianten-Bildfilter auf display:none gesetzt hat.
         Die haengen dann mit Breite 0 in der Liste: die Pfeile springen ins
         Leere und ein Klick aufs Thumbnail landet auf dem falschen Bild.
         Denselben Selektor setzt der Bildfilter weiter oben - hier noetig,
         weil er beim Laden nicht zwingend schon gelaufen ist. */
      f.options.cellSelector = '.Carousel__Cell:not(.VariantFilter--hidden), .Product__SlideItem:not(.VariantFilter--hidden)';
      f.reloadCells();
      /* 26.10.: Das Theme laesst resize() nur durch, wenn sich die Fensterbreite
         geaendert hat (iOS-Schutz, prueft maxCellHeight). Aendert sich nur das
         Layout (z. B. Sets: Bildbreite steht erst nach "Im Set enthalten" fest),
         bliebe Flickity auf der alten Breite - die Folien ueberlappen dann.
         Beim Laden und nach dem Bildfilter deshalb die Sperre einmal aufheben;
         resize() setzt maxCellHeight selbst wieder. */
      if (hart) f.maxCellHeight = 0;
      f.resize();
      if (f.slides && f.slides.length){
        f.select(Math.min(f.selectedIndex, f.slides.length - 1), false, true);
      }
      if (f.prevButton){ f.prevButton.update(); f.nextButton.update(); }
      aufraeumen(f);
    } catch(e){}
  }

  /* Leiste hoechstens so hoch wie das Bild - und sie endet genau an der
     Unterkante des letzten Thumbnails, das noch vollstaendig hineinpasst.
     Sonst stuende unter der Plakette noch ein angeschnittenes Thumbnail und
     die Zahl darauf saehe falsch aus. Gerechnet wird ueber die tatsaechlichen
     Unterkanten, nicht ueber eine feste Schrittweite - die Thumbnails koennen
     unterschiedlich hoch sein. */
  function hoeheAngleichen(t){
    var h = Math.round(t.show.getBoundingClientRect().height);
    if (h <= 40) return;
    t.sc.style.maxHeight = h + 'px';
    var liste = sichtbare(t);
    if (!liste.length) return;
    var oben = t.sc.getBoundingClientRect().top;
    var kante = 0;
    liste.forEach(function(a){
      var unten = Math.round(a.getBoundingClientRect().bottom - oben);
      if (unten <= h + 1) kante = unten;
    });
    if (kante > 20) t.sc.style.maxHeight = kante + 'px';
  }

  /* Sticky nur, solange die Galerie ins Fenster passt. Der Shop hat keine
     mitlaufende Kopfzeile, deshalb darf der Abstand nach oben kleiner werden,
     wenn das Bild sonst knapp nicht hineinpasst. Passt es gar nicht, faellt
     sticky weg - sonst laege der untere Bildrand dauerhaft unter dem Rand. */
  function stickyPruefen(t){
    var h = t.gal.getBoundingClientRect().height;
    var luft = 16;
    var platz = window.innerHeight - h - luft;
    if (platz < luft){
      /* Hoeher als das Fenster (z. B. Sets mit "Im Set enthalten"): die Galerie scrollt mit, bis ihr unterer
         Rand sichtbar ist, und bleibt dann stehen. */
      t.gal.classList.remove('fg_galerie_hoch');
      t.gal.style.top = Math.round(window.innerHeight - h - luft) + 'px';
    } else {
      t.gal.classList.remove('fg_galerie_hoch');
      t.gal.style.top = Math.min(112, platz) + 'px';
    }
  }

  function plakette(t){
    [].forEach.call(t.sc.querySelectorAll('.fg_mehr'), function(x){ x.remove(); });
    [].forEach.call(t.sc.querySelectorAll('.fg_thumb_stumm'), function(x){ x.classList.remove('fg_thumb_stumm'); });
    [].forEach.call(t.sc.querySelectorAll('[data-fg-tab]'), function(x){ x.removeAttribute('tabindex'); x.removeAttribute('data-fg-tab'); });
    if (window.innerWidth < MIN) return;
    var liste = sichtbare(t);
    if (liste.length < 2) return;
    var kasten = t.sc.getBoundingClientRect();
    var drunter = 0, letzter = null;
    liste.forEach(function(a){
      var r = a.getBoundingClientRect();
      if (r.bottom > kasten.bottom + 1){
        drunter++;
        /* Abgeschnittene Thumbnails auch aus der Tabreihenfolge nehmen - sonst
           scrollt der Fokus die Leiste, und die Zaehlung stimmt nicht mehr. */
        a.setAttribute('tabindex', '-1');
        a.setAttribute('data-fg-tab', '1');
      } else {
        letzter = a;
      }
    });
    if (!drunter || !letzter) return;
    var p = document.createElement('span');
    p.className = 'fg_mehr';
    p.textContent = '+' + drunter;
    letzter.appendChild(p);
    letzter.classList.add('fg_thumb_stumm');
  }

  /* Das Theme setzt "is-selected" in der Leiste ueber die Medien-ID. Der
     Konfigurator-Eintrag hat keine und wuerde deshalb ewig markiert bleiben,
     auch wenn laengst ein Bild zu sehen ist. Hier wird er mitgefuehrt. */
  function konfiMarkieren(f){
    if (!f || !f.selectedElement) return;
    var aktiv = f.selectedElement.getAttribute('data-media-type') === 'konfigurator';
    /* Der mobile Punkt haengt NICHT an .Product--fgGalerie - er gehoert zur
       Punktleiste des Konfigurators und gibt es auch ohne das neue Layout. */
    var punkt = document.querySelector('[data-fg-konfi-dot]');
    if (punkt) punkt.classList.toggle('is-selected', aktiv);
    /* Mobile Punkte: das Theme markiert nach Medienposition und liegt wegen des Konfigurator-Punkts eins daneben.
       Markiert wird der Punkt, dessen data-index die aktive Folie ist; ausgeblendete Bilder markieren den "+N"-Punkt. */
    setTimeout(function(){
      var mehr = false, liste = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
      [].forEach.call(liste, function(x){
        var an = parseInt(x.getAttribute('data-index'), 10) === f.selectedIndex;
        if (x.parentNode.classList.contains('fg_dot_aus')){ if (an) mehr = true; an = false; }
        x.classList.toggle('is-selected', an);
      });
      var m = document.querySelector('.Product__SlideshowMobileNav li[data-mehr] .dot');
      if (m && mehr) m.classList.add('is-selected');
    }, 0);
    var thumb = document.querySelector('.Product--fgGalerie [data-fg-konfi]');
    if (!thumb) return;
    thumb.classList.toggle('is-selected', aktiv);
    /* Steht der Konfigurator vorn, darf kein Bild-Thumbnail markiert sein. */
    if (aktiv){
      [].forEach.call(document.querySelectorAll('.Product--fgGalerie .Product__SlideshowNavImage[data-media-id].is-selected'),
        function(x){ x.classList.remove('is-selected'); });
    }
  }

  function aktualisieren(){
    var t = teile();
    if (!t) return;
    if (window.innerWidth < MIN){
      t.sc.style.maxHeight = '';
      t.gal.style.top = '';
      t.gal.classList.remove('fg_galerie_hoch');
      [].forEach.call(t.sc.querySelectorAll('.fg_mehr'), function(x){ x.remove(); });
      [].forEach.call(t.sc.querySelectorAll('.fg_thumb_stumm'), function(x){ x.classList.remove('fg_thumb_stumm'); });
      return;
    }
    t.sc.scrollTop = 0;   /* die Leiste blaettert nicht, sie zeigt immer von oben */
    hoeheAngleichen(t);
    stickyPruefen(t);
    plakette(t);
  }

  var wartet;
  function spaeter(){
    clearTimeout(wartet);
    wartet = setTimeout(function(){ neuVermessen(); aktualisieren(); }, 150);
  }

  function start(){
    if (!teile()) return;
    aktualisieren();

    window.addEventListener('load', function(){
      setTimeout(function(){ neuVermessen(true); aktualisieren(); }, 300);
    });
    /* Bewusst kein lazyloaded-Hook mehr: der Bildrahmen haengt am
       Seitenverhaeltnis, nicht am geladenen Bild. Frueher loeste jedes
       nachgeladene Bild ein reloadCells aus - mitten in der Pfeil-Animation. */
    window.addEventListener('resize', spaeter);
    document.addEventListener('fg:variantFilter:after', function(){
      setTimeout(function(){ neuVermessen(true); aktualisieren(); }, 60);
    });

    var f = flick();
    if (f && f.on){
      f.on('select', function(){ aufraeumen(f); konfiMarkieren(f); });
      f.on('settle', function(){ aufraeumen(f); konfiMarkieren(f); });
    }

    /* Im Hintergrundtab drosselt der Browser die Bildwiederholung. Eine
       Bewegung, die dabei begonnen hat, bleibt stehen - beim Zurueckkommen
       einmal nachmessen. */
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'visible') setTimeout(function(){ neuVermessen(); aktualisieren(); }, 100);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ===========================================================================
   Nutzung & Pflege  (snippets/product-hint.liquid)
   ---------------------------------------------------------------------------
   Zwei kleine Aufgaben:

   1. Der Begriff "pflanzwasserdicht" traegt ein ⓘ. Ein Klick klappt die
      Erklaerung unter der Zeile auf, der naechste klappt sie zu. Bewusst ein
      Klick und kein Hover: auf dem Handy gibt es kein Hover.

   2. Beim Wechsel der Groesse aendert sich der Text. Ob ein Gefaess
      pflanzwasserdicht ist und ob es einen Zwischenboden hat, haengt an der
      VARIANTE, nicht am Produkt - bei Patt Grau zum Beispiel sind S bis XXL
      pflanzwasserdicht und XXXL nicht.

   Der Text wird hier NICHT gebaut. product-hint.liquid rendert jede Variante
   fertig und legt die Bausteine als JSON daneben; hier wird nur getauscht.
   Sonst muesste jede Formulierung an zwei Stellen gepflegt werden - und genau
   so laufen Liquid und JavaScript mit der Zeit auseinander.
   =========================================================================== */
(function () {
  function start() {
    var wurzel = document.getElementById('fg-nutzung-block');
    if (!wurzel) return;
    /* Nur einmal einhaengen. Shopify-Sections werden im Theme-Editor neu
       gezeichnet und manche Themes fuehren ihre Skripte dabei erneut aus -
       zwei Klick-Handler am selben Knopf wuerden die Erklaerung auf- und im
       selben Klick wieder zuklappen, der Knopf waere scheinbar kaputt. */
    if (wurzel.getAttribute('data-fg-nutzung-an') === '1') return;
    wurzel.setAttribute('data-fg-nutzung-an', '1');

    var liste = document.getElementById('fg-nutzung-liste');
    var topf  = wurzel.querySelector('script[type="application/json"][data-fg-nutzung]');
    var daten = {};
    if (topf) {
      try { daten = JSON.parse(topf.textContent) || {}; }
      catch (e) { daten = {}; }
    }

    /* ── 1) ⓘ auf- und zuklappen ──
       Delegiert an der Wurzel, weil die Liste beim Groessenwechsel komplett
       neu geschrieben wird - ein Handler direkt am Knopf waere danach weg. */
    wurzel.addEventListener('click', function (e) {
      var knopf = e.target.closest ? e.target.closest('.FgTerm') : null;
      if (!knopf || !wurzel.contains(knopf)) return;
      e.preventDefault();
      var offen = knopf.getAttribute('aria-expanded') === 'true';
      knopf.setAttribute('aria-expanded', offen ? 'false' : 'true');
      var kasten = document.getElementById(knopf.getAttribute('aria-controls'));
      if (kasten) kasten.hidden = offen;
    });

    /* ── 2) Groessenwechsel ──
       Fehlt die Variante in den Daten, bleibt der alte Text stehen. Das ist
       besser als eine leere Liste: lieber der Text der Nachbargroesse als gar
       keiner - falsch werden kann er nur, wenn Shopify eine Variante meldet,
       die es im Produkt nicht gibt. */
    function zeige(variantenId) {
      if (!liste || variantenId == null) return;
      var html = daten[String(variantenId)];
      if (typeof html !== 'string') return;
      if (liste.innerHTML === html) return;
      liste.innerHTML = html;
    }

    document.addEventListener('theme:variant:change', function (e) {
      if (e.detail && e.detail.variant) zeige(e.detail.variant.id);
    });
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) zeige(e.detail.variant.id);
    });
    /* Rueckfall: das versteckte Feld [name="id"], das jede Variantenauswahl
       setzt - dieselbe Absicherung wie in variant-abmessungen.liquid. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        setTimeout(function () { zeige(e.target.value); }, 50);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

